import { useState, useEffect, useMemo, useRef } from "react";
import { useMaterialUIController, setSelection, setMiniSidenav } from "context";
import {
  Grid,
  Card,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  IconButton,
  Box,
  Menu,
  useMediaQuery,
  Checkbox,
  Tooltip,
  TextField,
  Radio,
  Collapse,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  FormControl,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/tables/data/authorsTableData";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import {
  Select,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Badge,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { usePublications } from "context/PublicationProvider";
import MDTypography from "components/MDTypography";
import Popup from "./data/popup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EditPublicationModel from "./data/EditPublicationModal ";
import * as XLSX from "xlsx";
import { ArrowDropDown, Logout } from "@mui/icons-material";
import GridOnIcon from "@mui/icons-material/GridOn";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ExcelFileIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="#EAF7EF" stroke="#CDEBD9" />
    <rect x="6" y="5.5" width="12" height="13" rx="1.5" fill="#1E9E5A" />
    <rect x="7.5" y="7" width="9" height="10" rx="0.5" fill="#EAF7EF" />
    <rect x="7.5" y="7" width="9" height="2.4" fill="#1E9E5A" />
    <line x1="12" y1="9.4" x2="12" y2="17" stroke="#1E9E5A" strokeWidth="0.9" />
    <line x1="7.5" y1="12.2" x2="16.5" y2="12.2" stroke="#1E9E5A" strokeWidth="0.9" />
    <line x1="7.5" y1="14.6" x2="16.5" y2="14.6" stroke="#1E9E5A" strokeWidth="0.9" />
  </svg>
);

dayjs.extend(utc);

function Tables() {
  const { fetchPublications, news, offers, fetchOffers } = usePublications();
  const [controller, dispatch, handleSignOut, fetchRegions] = useMaterialUIController();
  const { regions, miniSidenav } = controller;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  let [maxGstPrice, setMaxGstPrice] = useState(0);
  let [minGstPrice, setMinGstPrice] = useState(0);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { columns, rows: fetchedRows, customStyles } = authorsTableData();
  const [sliderRange, setSliderRange] = useState([0, 0]);
  const [priceRange, setPriceRange] = useState([0, 0]);
  const [rows, setRows] = useState([]);
  // Tables function ke andar top par
  const [downloadButtonLink, setDownloadButtonLink] = useState("");
  const { selection } = controller;
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    index2: null,
    doFollow2: null,
    platformName: null,
  });
  const [uploading, setUploading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMarginModalOpen, setMarginModalOpen] = useState(false);
  const [margin, setMargin] = useState("");
  const [isUSDModalOpen, setUSDModalOpen] = useState(false);
  const [USD, setUSD] = useState("");
  const [editId, setEditId] = useState();
  const [deleteBox, setdeleteBox] = useState(false);
  const [deletePackageBox, setdeletePackageBox] = useState(false);
  const [deletePackageId, setdeletePackageId] = useState("");
  const [deleteId, setdeleteId] = useState("");
  const [mediaOptions, setMediaOptions] = useState([]);

  const [genresOptions, setGenresOptions] = useState([]);
  const [disclaimerOptions, setDisclaimerOptions] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);

  const [openDoFollow, setOpenDoFollow] = useState(false);
  const [OpenIndex, setOpenIndex] = useState(false);
  const [showFiltersMobile, setShowFiltersMobile] = useState(false);

  const [genreList, setGenreList] = useState([]);
  const [disclaimerList, setDisclaimerList] = useState([]);
  const [filteredPublications, setFilteredPublications] = useState([]);

  const [selectedGenres, setSelectedGenres] = useState([]);
  const [selectedDisclaimer, setSelectedDisclaimer] = useState([]);
  const [opengenre, setOpengenre] = useState(false);
  const [openDisclaimer, setOpenDisclaimer] = useState(false);
  const [packagePublicationIds, setPackagePublicationIds] = useState([]);
  const [rowss, setRowss] = useState([]);
  const [clearFilterTrigger, setClearFilterTrigger] = useState(0);

  const [sortOption, setSortOption] = useState("default");

  // 📱 Mobile-only Publication List state (does not affect desktop DataTable)
  const [mobileSearchTerm, setMobileSearchTerm] = useState("");
  const [mobilePage, setMobilePage] = useState(0);
  const [mobileRowsPerPage, setMobileRowsPerPage] = useState(50);

  const [publicationData, setPublicationData] = useState({
    publication: "",
    orgPrice: "",
    wordsAllowed: "",
    backlinksAllowed: "",
    tat: "",
    index2: "no",
    doFollow2: "no",
    indexed: true,
    doFollow: true,
    genres: [],
    disclaimer: [],
    sample: "",
    daChecker: "",
    trafficChecker: "",
    modeType: "",
    packageName: "",
    platformName: "",
    collab: "no",
    packageId: ''
  });

  const [EditpublicationData, setEditPublicationData] = useState({
    publication: "",
    orgPrice: "",
    wordsAllowed: "",
    backlinksAllowed: "",
    tat: "",
    indexed: true,
    doFollow: true,
    index2: "no",
    doFollow2: "no",
    genres: [],
    disclaimer: [],
    sample: "",
    daChecker: "",
    trafficChecker: "",
    modeType: "",
  });

  const [isEdit, setIsEdit] = useState(false);
  const [originalPublicationList, setOriginalPublicationList] = useState([]);

  useEffect(() => {
    fetchgenreDisclaimer();
    fetchRegions();
    fetchAppLink();
  }, []);

  const userRole = localStorage.getItem("userRole");

  const [filtersForMode, setFiltersForMode] = useState({
    index2: "",
    modeType: "",
  });

  const [publicationInput, setPublicationInput] = useState({ name: "", link: "" });
  const [publicationList, setPublicationList] = useState([]);
  const [packages, setPackages] = useState(false);
  const [showPublicationList, setShowPublicationList] = useState(false);

  const handleChangeForMode = (event) => {
    const { name, value } = event.target;
    setFiltersForMode((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleLinkChange = async () => {
    const newLink = prompt("Enter new Download Link:", downloadButtonLink);

    if (newLink !== null && newLink !== "") {
      try {
        const sessionToken = localStorage.getItem("sessionToken");
        // Query param format as per your last request
        const response = await axios.post(
          `https://api.exampladmedia.com/api/publications/setAppLink?url=${encodeURIComponent(newLink)}`,
          {},
          { headers: { Authorization: sessionToken } }
        );

        if (response.status === 200 || response.status === 201) {
          setDownloadButtonLink(newLink); // 👈 Immediate state update
          setSnackbarMessage("Download Packages link updated successfully!");
          setOpenSnackbar(true);
        }
      } catch (error) {
        setSnackbarMessage("Failed to update link.");
        setOpenSnackbar(true);
      }
    }
  };

  // Function to fetch link from API
  const fetchAppLink = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) return;

      const response = await axios.get("https://api.exampladmedia.com/api/publications/getAppLink", {
        headers: { Authorization: sessionToken }
      });

      // Screenshot ke mutabiq data direct string hai
      if (response.data) {
        setDownloadButtonLink(response.data); // Pure string ko set karein
        console.log("Link Fetched successfully:", response.data);
      }
    } catch (error) {
      console.error("Error fetching app link:", error);
    }
  };

  const [filteredData, setFilteredData] = useState([]);
  const filteredRowsForMode = rows.filter((row) => {
    const matchesIndexed =
      filtersForMode.index2 === "" ||
      row.index2.toLowerCase() === filtersForMode.index2.toLowerCase();
    const matchesModeType =
      filtersForMode.modeType === "" || row.modeType === filtersForMode.modeType;
    return matchesIndexed && matchesModeType;
  });

  const [openModeType, setOpenModeType] = useState(false);
  const [allData, setAllData] = useState([]);
  const [genreData, setGenreData] = useState([]);
  const [disclaimerData, setDisclaimerData] = useState([]);
  const [genreAnchorEl, setGenreAnchorEl] = useState(null);
  const [disclaimerAnchorEl, setDisclaimerAnchorEl] = useState(null);
  const [showContent, setShowContent] = useState(false);

  const [openPopup, setOpenPopup] = useState(false);
  const [minInput, setMinInput] = useState("");
  const [maxInput, setMaxInput] = useState("");
  const [minFixed, setMinFixed] = useState("");
  const [maxFixed, setMaxFixed] = useState("");
  const [searchText, setSearchText] = useState("");

  const filterRows = (rows) => {
    return rows.filter((row) => {
      const matchesGenres =
        selectedGenres.length === 0 || selectedGenres.every((genre) => row.genres.includes(genre));
      const matchesDisclaimer =
        selectedDisclaimer.length === 0 ||
        selectedDisclaimer.every((disclaimer) => row.disclaimer.includes(disclaimer));
      return matchesGenres && matchesDisclaimer;
    });
  };

  // FIXED: Re-fetch when selection or customer changes
  useEffect(() => {
    if (selectedCustomer) {
      const userId = selectedCustomer.userId;
      fetchCustomerPublications(userId);
    } else {
      fetchPublications();
    }
    setSelected([]); // Reset selection when customer changes
  }, [selectedCustomer, selection]);

  const fetchCustomerPublications = async (userId) => {
    try {
      setLoading(true);
      const sessionToken = localStorage.getItem("sessionToken");
      const response = await axios.get(
        `https://api.exampladmedia.com/api/publications/dashboard/${userId}`,
        {
          headers: {
            Authorization: sessionToken,
          },
        }
      );

      let rawData = [];
      if (Array.isArray(response.data)) {
        rawData = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        rawData = response.data.data;
      }

      if (selection === "package") {
        rawData = rawData.filter(item => Boolean(item.packageName));
      } else {
        rawData = rawData.filter(item => !item.packageName);
      }


      let formattedRows = [];

      if (selection === "package") {
        const packageMap = {};

        rawData.forEach(item => {
          const pkgName = item.packageName;
          if (!pkgName) return;

          if (!packageMap[pkgName]) {
            packageMap[pkgName] = {
              userId: item.userId,
              packageName: pkgName,
              orgPrice: item.orgPrice,
              wordsAllowed: item.wordsAllowed,
              backlinksAllowed: item.backlinksAllowed,
              tat: item.tat,
              index2: item.index2 || "NO",
              doFollow2: item.doFollow2 || "NO",
              indexed: item.indexed ?? true,
              doFollow: item.doFollow ?? true,
              genres: item.genres || [],
              platformName: item.platformName, // 👈 JSON: "69994da2711ee058fc17059d"
              collab: item.collab || "no",     // 👈 JSON: "maybe"
              sampleUrls: Array.isArray(item.sampleUrls)
                ? item.sampleUrls
                : [],
              disclaimer: item.disclaimer || [],
              modeType: item.modeType || "",
              lastmodifiedBy: item.lastmodifiedBy,
              lastUpdateDate: item.lastUpdateDate,
              createdDate: item.createdDate,
              gstPrice: item.gstPrice,
              usdPrice: item.usdPrice,
              publications: [],
            };
          }

          // ✅ CORRECT SOURCE (ARRAY BASED)
          (item.publicationNames || []).forEach((name, index) => {
            packageMap[pkgName].publications.push({
              name,
              link: item.sampleUrls?.[index] || "",
            });
          });
        });

        formattedRows = Object.values(packageMap).map(pkg => ({
          packageName: pkg.packageName,
          platformName: pkg.platformName || "",
          /* ================= PUBLICATIONS COLUMN ================= */
          publication: (
            <MDBox sx={{ maxWidth: "120px", whiteSpace: "normal", wordBreak: "break-word" }}>
              {pkg.platformName}
            </MDBox>
          ),

          // 2. Collab Column
          collab: pkg.collab,
          // collab: pkg.collab.toUpperCase(),

          // 3. Sample Column (Showing first sample for the package)
          sample: pkg.sampleUrls?.[0] || "-",
          publicationText: pkg.publications.map(p => p.name).join(", "),

          /* ================= PRICING ================= */
          orgPrice: pkg.orgPrice || "",
          gstPrice: pkg.gstPrice ?? "0.00",
          usdPrice: pkg.usdPrice != null ? Number(pkg.usdPrice).toFixed(2) : "0.00",
          marginPrice: 0,

          /* ================= RULES ================= */
          wordsAllowed: pkg.wordsAllowed || 0,
          backlinksAllowed: pkg.backlinksAllowed ?? "N/A",
          tat: pkg.tat || "N/A",
          sponsored: "No",
          indexed: pkg.indexed ? "Yes" : "No",
          doFollow: pkg.doFollow ? "Yes" : "No",
          doFollow2: pkg.doFollow2,
          index2: pkg.index2,
          collab: pkg.collab,
          /* ================= META ================= */
          genres: Array.isArray(pkg.genres) ? pkg.genres.join(", ") : "",
          disclaimer: Array.isArray(pkg.disclaimer) ? pkg.disclaimer.join(", ") : "",

          sample: Array.isArray(pkg.sampleUrls) ? pkg.sampleUrls.join(", ") : "",

          daChecker: <ClearIcon />,
          trafficChecker: <ClearIcon />,
          modeType: pkg.modeType,

          lastmodifiedBy: pkg.lastmodifiedBy,
          lastmodifiedDate: pkg.lastUpdateDate
            ? dayjs(pkg.lastUpdateDate).format("DD-MMM-YYYY")
            : "-",
          createdDate: pkg.createdDate
            ? dayjs(pkg.createdDate).format("DD-MMM-YYYY")
            : "-",

          /* ================= ACTION ================= */
          action: (
            <MDBox display="flex" gap={1}>
              {userRole === "SUPER_ADMIN" && (
                <>
                  <IconButton
                    size="small"
                    sx={{ border: "1px solid #e0e0e0", borderRadius: "6px" }}
                    onClick={() => {
                      setPublicationData({
                        orgPrice: pkg.orgPrice || "",
                        wordsAllowed: pkg.wordsAllowed || "",
                        backlinksAllowed: pkg.backlinksAllowed || "",
                        tat: pkg.tat || "",
                        index2: pkg.index2 || "no",
                        platformName: pkg.platformName || "", // Platform load karne ke liye
                        collab: (pkg.collab || "no").toLowerCase(), // Collab radio ke liye
                        sample: Array.isArray(pkg.sampleUrls) ? pkg.sampleUrls[0] : (pkg.sample || ""),
                        // collab: pkg.collab || "no",
                        doFollow2: pkg.doFollow2 || "no",
                        genres: Array.isArray(pkg.genres) ? pkg.genres : [],
                        disclaimer: Array.isArray(pkg.disclaimer) ? pkg.disclaimer : [],
                        modeType: pkg.modeType || "",
                        packageName: pkg.packageName || "",
                        packageId: pkg.userId
                      });

                      setPublicationList(
                        pkg.publications.map(p => ({
                          name: p.name,
                          link: p.link || "",
                        }))
                      );

                      setOriginalPublicationList(
                        pkg.publications.map(p => ({ ...p }))
                      );

                      setPackages(true);
                      setIsEdit(true);
                      setIsModalOpen(true);
                    }}
                  >
                    <EditIcon style={{ color: "green" }} />
                  </IconButton>

                  <IconButton
                    size="small"
                    sx={{ border: "1px solid #e0e0e0", borderRadius: "6px" }}
                    onClick={() => handleConfirmDeletePackage(pkg.packageName)}
                  >
                    <DeleteIcon style={{ color: "red" }} />
                  </IconButton>
                </>
              )}
            </MDBox>
          ),
        }));
      }

      else {
        // SINGLE PUBLICATION MODE
        formattedRows = rawData.map((item) => ({
          ...item,
          userId: item.userId,
          publication: item.sample ? (
            <a
              href={item.sample}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "blue",
                pointerEvents: "auto",
                textDecoration: "none",
              }}
            >
              {item.publication}
            </a>
          ) : (
            <span style={{ color: "gray" }}>{item.publication}</span>
          ),
          platformName: item.platformName || item.platform || "",
          publicationText: item.publication || "N/A",
          marginPrice: parseInt(item.marginPrice, 10) || 0,
          platformName: item.platformName || item.platform || "",
          orgPrice: item.orgPrice || "",
          gstPrice: item.gstPrice ?? "0.00",                    // Direct from API
          usdPrice: item.usdPrice != null ? Number(item.usdPrice).toFixed(2) : "0.00", // 2 decimals
          lastmodifiedBy: item.lastmodifiedBy,
          lastmodifiedDate: item.lastUpdateDate ? dayjs(item.lastUpdateDate).format("DD-MMM-YYYY") : "-",
          createdDate: item.createdDate ? dayjs(item.createdDate).format("DD-MMM-YYYY") : "-",
          modeType: item.modeType || "",
          wordsAllowed: parseInt(item.wordsAllowed, 10) || 0,
          backlinksAllowed: item.backlinksAllowed !== null ? item.backlinksAllowed : "N/A",
          tat: item.tat || "N/A",
          sponsored: item.sponsored ? "Yes" : "No",
          indexed: item.indexed ? "Yes" : "No",
          doFollow: item.doFollow ? "Yes" : "No",
          doFollow2: item.doFollow2 || "NO",
          index2: item.index2 || "NO",
          genres: Array.isArray(item.genres) ? item.genres.join(", ") : "",
          disclaimer: Array.isArray(item.disclaimer) ? item.disclaimer.join(", ") : "",
          sample: item.sample ? (
            <a href={item.sample} target="_blank" rel="noopener noreferrer">
              Sample
            </a>
          ) : (
            <Tooltip title="Sample unavailable to check" arrow placement="top">
              <span>N/A</span>
            </Tooltip>
          ),
          daChecker: item.daChecker ? (
            <a href={item.daChecker} target="_blank" rel="noopener noreferrer" style={{ color: "#1A73E8", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <VisibilityIcon fontSize="small" />
            </a>
          ) : (
            <Tooltip title="Sample unavailable to check DA" arrow placement="top">
              <ClearIcon />
            </Tooltip>
          ),
          trafficChecker: item.trafficChecker ? (
            <a href={item.trafficChecker} target="_blank" rel="noopener noreferrer" style={{ color: "#1A73E8", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <TrendingUpIcon fontSize="small" />
            </a>
          ) : (
            <Tooltip title="Sample unavailable to check Traffic" arrow placement="top">
              <ClearIcon />
            </Tooltip>
          ),
          packageName: item.packageName || "",
          action: (
            <MDBox display="flex" gap={1}>
              {userRole === "SUPER_ADMIN" && (
                <>
                  <IconButton
                    color="primary"
                    size="small"
                    sx={{ border: "1px solid #e0e0e0", borderRadius: "6px" }}
                    onClick={() => {
                      setEditId(item.userId);
                      setEditPublicationData({
                        publication: item.publication || "",
                        orgPrice: item.orgPrice || "",
                        wordsAllowed: item.wordsAllowed || "",
                        backlinksAllowed: item.backlinksAllowed || "",
                        tat: item.tat || "",
                        index2: item.index2 || "",
                        indexed: true,
                        doFollow: true,
                        doFollow2: item.doFollow2 || "",
                        genres: Array.isArray(item.genres) ? item.genres : [],
                        disclaimer: Array.isArray(item.disclaimer) ? item.disclaimer : [],
                        sample: item.sample || "",
                        daChecker: item.daChecker || "",
                        trafficChecker: item.trafficChecker || "",
                        modeType: item.modeType || "",
                      });
                      setIsModalOpen(false);
                    }}
                  >
                    <EditIcon style={{ color: "green" }} />
                  </IconButton>
                  <IconButton
                    color="secondary"
                    size="small"
                    sx={{ border: "1px solid #e0e0e0", borderRadius: "6px" }}
                    onClick={() => handleConfirmDelete(item.userId)}
                  >
                    <DeleteIcon style={{ color: "red" }} />
                  </IconButton>
                </>
              )}
            </MDBox>
          ),
        }));
      }

      const sortedRows = formattedRows.sort((a, b) => {
        if (a.modeType === "INDIA" && b.modeType !== "INDIA") return -1;
        if (a.modeType !== "INDIA" && b.modeType === "INDIA") return 1;
        return a.publicationText.localeCompare(b.publicationText);
      });

      setRows(sortedRows);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching customer publications:", error);
      setRows([]);
      setLoading(false);
    }
  };

  const fetchCustomers = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      const response = await axios.get("https://api.exampladmedia.com/auth/getAllUsers", {
        headers: {
          Authorization: sessionToken,
        },
      });
      const customerUsers = response.data.filter((user) => user.userRole);
      setCustomers(customerUsers);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }
      const response = await axios.get("https://api.exampladmedia.com/auth/getAllUsers", {
        headers: {
          Authorization: sessionToken,
        },
      });
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }
      const response = await axios.get("https://api.exampladmedia.com/api/genres/getall", {
        headers: {
          Authorization: sessionToken,
        },
      });
      const { data } = response.data;
      setAllData(data);
      applyFilters(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const applyFilters = (data) => {
    const genreFiltered = data.filter((item) => item.type === "GENRE");
    setGenreData(genreFiltered);
    const disclaimerFiltered = data.filter((item) => item.type === "DISCLAIMER");
    setDisclaimerData(disclaimerFiltered);
    setLoading(false);
  };

  const handleOpenGenreDropdown = (event) => {
    setGenreAnchorEl(event.currentTarget);
  };

  const handleCloseGenreDropdown = () => {
    setGenreAnchorEl(null);
  };

  const handleOpenDisclaimerDropdown = (event) => {
    setDisclaimerAnchorEl(event.currentTarget);
  };

  const handleCloseDisclaimerDropdown = () => {
    setDisclaimerAnchorEl(null);
  };

  const handleChange = (event) => {
    let { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value || null,
    }));
  };

  const handleTemplateDownload = () => {

    let headers = [];
    let data = [];
    let filename = "";

    if (selection === "package") {
      // 📱 EXACT MATCH AS PER SCREENSHOT (Social Media Package Template)
      headers = [
        "Platform Name",
        "Social Media",
        "Collab",
        "Genre",
        "Sample",
        "TAT",
        "Price"
      ];

      data = [
        [
          "testing34",
          "LINKEDIN",
          "yes",
          "Business/News",
          "https://www.instagram.com/globalbizhour/",
          "72 Hrs",
          1180
        ],
      ];
      filename = "social_media_template.xlsx";
    } else {
      headers = [
        "Publication",
        "Price",
        "Words Allowed",
        "Backlinks Allowed",
        "TAT",
        "Index",
        "Do Follow",
        "Sample",
        "Region",
        "Genre",
        "Disclaimer",
      ];

      data = [
        [
          "Maintenance",
          250,
          1000,
          2,
          5,
          "Yes",
          "Yes",
          "https://techcrunch.com",
          "INDIA",
          "General News",
          "Yes",
        ],
      ];
      filename = "publication_template.xlsx";
    }

    // console.log("📋 Generated Headers for Template:", headers);

    // Row index 1 se header read karne ke liye pehli row khali ([]) rakhi hai
    const ws = XLSX.utils.aoa_to_sheet([[], headers, ...data]);

    // Clean alignment ke liye column width auto-adjust
    ws["!cols"] = headers.map(() => ({ width: 24 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template Data");

    XLSX.writeFile(wb, filename);
    console.log(`✅ [Template Download] File successfully generated: '${filename}'`);
  };

  const fetchgenreDisclaimer = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }
      const response = await axios.get("https://api.exampladmedia.com/api/genres/getall", {
        headers: {
          Authorization: sessionToken,
        },
      });
      const { data } = response.data;
      const genres = [];
      const disclaimers = [];
      data.forEach((item) => {
        if (item.type === "GENRE" && item.value) {
          genres.push(item.value);
        } else if (item.type === "DISCLAIMER" && item.value) {
          disclaimers.push(item.value);
        }
      });
      setGenresOptions([...new Set(genres)]);
      setDisclaimerOptions([...new Set(disclaimers)]);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // Fetch Media Platforms
  const fetchMediaPlatforms = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      const response = await axios.get(`https://api.exampladmedia.com/social-media/getAllMedia/all`, {
        headers: { Authorization: sessionToken },
      });
      setMediaOptions(response.data || []);
    } catch (error) {
      console.error("Error fetching social media platforms:", error);
    }
  };

  useEffect(() => {
    fetchMediaPlatforms();
  }, []);

  const handlePlatformsChange = (event, selectedOptions) => {
    setPublicationData((prev) => ({
      ...prev,
      platforms: selectedOptions.map(option => option.id),
    }));
  };

  const handleGenresChange = (event, newGenres) => {
    setPublicationData((prev) => ({
      ...prev,
      genres: newGenres,
    }));
  };

  const handleDisclamerChange = (event, newDisclaimer) => {
    setPublicationData((prev) => ({
      ...prev,
      disclaimer: newDisclaimer,
    }));
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPublicationList([]);
    setPublicationInput({ name: "", link: "" });
    setPackages(false);
    setPublicationData({
      publication: "",
      orgPrice: "",
      wordsAllowed: "",
      backlinksAllowed: "",
      tat: "",
      index2: "no",
      doFollow2: "no",
      indexed: true,
      doFollow: true,
      genres: [],
      disclaimer: [],
      sample: "",
      daChecker: "",
      trafficChecker: "",
      modeType: "",
      packageName: "",
    });
    setIsEdit(false);
    setOriginalPublicationList([]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPublicationData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const value = e.target.value;
    const name = e.target.name || "index2";
    setPublicationData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFocus = () => {
    if (!publicationData.sample) {
      setPublicationData((prevData) => ({
        ...prevData,
        sample: "",
      }));
    }
  };

  useEffect(() => {
    const gstPrices = rows.map((row) => parseFloat(row.gstPrice) || 0);
    const minPrice = Math.min(...gstPrices);
    const maxPrice = Math.max(...gstPrices);
    setMaxGstPrice(maxPrice);
    setSliderRange([minPrice, maxPrice]);
    const min = minInput !== "" ? Number(minInput) : minPrice;
    const max = maxInput !== "" ? Number(maxInput) : maxPrice;
    setPriceRange([min, max]);
  }, [rows, minInput, maxInput]);

  useEffect(() => {
    setFilters({
      index2: null,
      doFollow2: null,
    });
    setFiltersForMode({
      index2: "",
      modeType: "",
    });
    setSelectedGenres([]);
    setSelectedDisclaimer([]);
    setPriceRange([sliderRange[0], sliderRange[1]]);
    setMinInput("");
    setMaxInput("");
  }, [selection]);

  useEffect(() => {
    if (rows.length > 0) {
      const gstPrices = rows.map((row) => parseFloat(row.gstPrice) || 0);
      const minPrice = Math.min(...gstPrices);
      const maxPrice = Math.max(...gstPrices);
      setMaxGstPrice(maxPrice);
      setSliderRange([minPrice, maxPrice]);
      const min = minInput !== "" ? Number(minInput) : minPrice;
      const max = maxInput !== "" ? Number(maxInput) : maxPrice;
      setMinInput(min);
      setMaxInput(max);
      setPriceRange([min, max]);
    }
  }, [rows]);

  useEffect(() => {
    fetchData();
    fetchUsers();
    fetchCustomers();
  }, []);

  const handleSavePublication = async () => {
    const sessionToken = localStorage.getItem("sessionToken");
    const userName = localStorage.getItem("name");
    const currentDate = new Date().toISOString();

    if (!sessionToken) {
      setSnackbarMessage("Session token not found. Please log in again.");
      setOpenSnackbar(true);
      return;
    }

    /* ================= PACKAGE VALIDATION ================= */
    if (isPackage) {
      if (!publicationData.packageName?.trim()) {
        setSnackbarMessage("Publication name is required!");
        setOpenSnackbar(true);
        return;
      }

      if (parseFloat(publicationData.orgPrice) <= 0) {
        setSnackbarMessage("Package price must be greater than 0!");
        setOpenSnackbar(true);
        return;
      }
    }

    try {
      setLoading(true);

      /* =====================================================
         ================ PACKAGE CREATE / EDIT ===============
         ===================================================== */
      // if (packages) {
      //   const requestBody = {
      //     orgPrice: parseFloat(publicationData.orgPrice) || 0,
      //     marginPrice: null,
      //     usdPrice: null,
      //     wordsAllowed: parseInt(publicationData.wordsAllowed) || 0,
      //     backlinksAllowed: publicationData.backlinksAllowed || "yes",
      //     tat: publicationData.tat,
      //     sponsored: publicationData.sponsored ?? false,
      //     index2: publicationData.index2 || "no",
      //     indexed: publicationData.indexed ?? true,
      //     doFollow: publicationData.doFollow ?? true,
      //     doFollow2: publicationData.doFollow2 || "no",
      //     genres: publicationData.genres,
      //     disclaimer: publicationData.disclaimer,
      //     modeType: publicationData.modeType,
      //     packageName: publicationData.packageName,
      //     createdDate: currentDate,
      //     lastUpdateDate: currentDate,
      //     lastmodifiedBy: userName,
      //     pubType: "PACKAGE",
      //   };

      //   /* ===== CREATE PACKAGE (SINGLE API CALL) ===== */
      //   const response = await fetch(
      //     "https://api.exampladmedia.com/api/publications/addPublication",
      //     {
      //       method: "POST",
      //       headers: {
      //         Authorization: sessionToken,
      //         "Content-Type": "application/json",
      //       },
      //       body: JSON.stringify(requestBody),
      //     }
      //   );

      //   if (response.status === 201) {
      //     setSnackbarMessage(
      //       `Social Media "${publicationData.packageName}" ${isEdit ? "updated" : "created"
      //       } successfully!`
      //     );
      //     setOpenSnackbar(true);
      //     handleCloseModal();
      //     // fetchPublications();
      //     setTimeout(() => {
      //       fetchPublications();
      //     }, 2000);
      //   } else {
      //     const error = await response.text();
      //     setSnackbarMessage(`Package failed: ${error}`);
      //     setOpenSnackbar(true);
      //   }
      // }

      if (isPackage) {

        const selectedPlatform = mediaOptions.find(
          (opt) => opt.id === publicationData.platformName || opt.name === publicationData.platformName
        );

        const platformIdToSend = selectedPlatform ? selectedPlatform.id : publicationData.platformName;

        const requestBody = {
          platformName: platformIdToSend,
          collab: publicationData.collab,
          orgPrice: parseFloat(publicationData.orgPrice) || 0,
          marginPrice: null,
          usdPrice: null,
          wordsAllowed: parseInt(publicationData.wordsAllowed) || 0,
          backlinksAllowed: publicationData.backlinksAllowed || "yes",
          tat: publicationData.tat,
          sampleUrls: [publicationData.sample],
          sponsored: publicationData.sponsored ?? false,
          index2: publicationData.index2 || "no",
          indexed: publicationData.indexed ?? true,
          doFollow: publicationData.doFollow ?? true,
          doFollow2: publicationData.doFollow2 || "no",
          genres: publicationData.genres,
          disclaimer: publicationData.disclaimer,
          modeType: publicationData.modeType,
          packageName: publicationData.packageName,
          lastUpdateDate: currentDate,
          lastmodifiedBy: userName,
          pubType: "PACKAGE",
        };

        console.log("publicationData7878788", publicationData);

        /* ===== EDIT PACKAGE (DIRECT PUT CALL) ===== */
        if (isEdit) {
          const targetId = publicationData.packageId;
          await axios.put(
            `https://api.exampladmedia.com/api/publications/edit/${targetId}`,
            requestBody,
            {
              headers: {
                Authorization: sessionToken,
                "Content-Type": "application/json",
              },
            }
          );

          setSnackbarMessage("Social Media updated successfully!");
          setOpenSnackbar(true);
          handleCloseModal();
          fetchPublications();
        }

        /* ===== CREATE PACKAGE ===== */
        else {
          const response = await fetch(
            "https://api.exampladmedia.com/api/publications/addPublication",
            {
              method: "POST",
              headers: {
                Authorization: sessionToken,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ...requestBody,
                createdDate: currentDate,
              }),
            }
          );

          if (response.status === 201) {
            setSnackbarMessage("Social Media created successfully!");
            setOpenSnackbar(true);
            handleCloseModal();
            fetchPublications();
          } else {
            const error = await response.text();
            setSnackbarMessage(`Social Media failed: ${error}`);
            setOpenSnackbar(true);
          }
        }
      }

      else if (isEdit) {
        const requestBody = {
          publication: EditpublicationData.publication,
          orgPrice: parseFloat(EditpublicationData.orgPrice) || 0,
          marginPrice: null,
          usdPrice: null,
          wordsAllowed: parseInt(EditpublicationData.wordsAllowed) || 0,
          backlinksAllowed: EditpublicationData.backlinksAllowed || "yes",
          tat: EditpublicationData.tat,
          sponsored: EditpublicationData.sponsored ?? false,
          index2: EditpublicationData.index2 || "no",
          indexed: EditpublicationData.indexed ?? true,
          doFollow: EditpublicationData.doFollow ?? true,
          doFollow2: EditpublicationData.doFollow2 || "no",
          genres: EditpublicationData.genres,
          disclaimer: EditpublicationData.disclaimer,
          sample: EditpublicationData.sample,
          modeType: EditpublicationData.modeType,
          packageName: EditpublicationData.packageName,
          lastUpdateDate: currentDate,
          lastmodifiedBy: userName,
        };

        await axios.put(
          `https://api.exampladmedia.com/api/publications/edit/${editId}`,
          requestBody,
          {
            headers: {
              Authorization: sessionToken,
              "Content-Type": "application/json",
            },
          }
        );

        setSnackbarMessage("Publication updated successfully!");
        setOpenSnackbar(true);
        handleCloseModal();
        fetchPublications();
      }

      /* =====================================================
         ============ SINGLE PUBLICATION CREATE ===============
         ===================================================== */
      else {
        const requestBody = {
          publication: publicationData.publication,
          orgPrice: parseFloat(publicationData.orgPrice) || 0,
          marginPrice: null,
          usdPrice: null,
          wordsAllowed: parseInt(publicationData.wordsAllowed) || 0,
          backlinksAllowed: publicationData.backlinksAllowed || "yes",
          tat: publicationData.tat,
          sponsored: publicationData.sponsored ?? false,
          index2: publicationData.index2 || "no",
          indexed: publicationData.indexed ?? true,
          doFollow: publicationData.doFollow ?? true,
          doFollow2: publicationData.doFollow2 || "no",
          genres: publicationData.genres,
          disclaimer: publicationData.disclaimer,
          sample: publicationData.sample,
          modeType: publicationData.modeType,
          packageName: publicationData.packageName,
          createdDate: currentDate,
          lastUpdateDate: currentDate,
          lastmodifiedBy: userName,
          pubType: ""
        };

        const response = await fetch(
          "https://api.exampladmedia.com/api/publications/addPublication",
          {
            method: "POST",
            headers: {
              Authorization: sessionToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        if (response.status === 201) {
          setSnackbarMessage("Publication added successfully!");
          setOpenSnackbar(true);
          handleCloseModal();
          fetchPublications();
        } else {
          const error = await response.text();
          setSnackbarMessage(`Failed to save publication: ${error}`);
          setOpenSnackbar(true);
        }
      }
    } catch (error) {
      setSnackbarMessage(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong!"
      );
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
      setIsFilterModalOpen(false);
    }
  };

  const handlePublicationChange = (index, field, value) => {
    const updated = [...publicationList];
    updated[index][field] = value;
    setPublicationList(updated);
  };

  const handleAddPublicationAtIndex = (index) => {
    const updated = [...publicationList];
    updated.splice(index + 1, 0, { name: "", link: "" });
    setPublicationList(updated);
  };

  const handleConfirmRow = (index) => {
    const row = publicationList[index];

    if (!row.name?.trim()) {
      setSnackbarMessage("Publication name required");
      setOpenSnackbar(true);
      return;
    }

    setSnackbarMessage(`"${row.name}" updated`);
    setOpenSnackbar(true);
  };

  const fields = [
    {
      label: "Publication Name",
      name: "publication",
      value: EditpublicationData.publication,
      type: "text",
    },
    {
      label: "Original Price",
      name: "orgPrice",
      value: EditpublicationData.orgPrice,
      type: "number",
    },
    {
      label: "Words Allowed",
      name: "wordsAllowed",
      value: EditpublicationData.wordsAllowed,
      type: "number",
    },
    {
      label: "Backlinks Allowed",
      name: "backlinksAllowed",
      value: EditpublicationData.backlinksAllowed,
      type: "text",
    },
    {
      label: "Sample",
      name: "sample",
      value: EditpublicationData.sample,
      type: "text",
    },
    {
      label: "TAT",
      name: "tat",
      value: EditpublicationData.tat,
      type: "text",
    },
    {
      label: "Genre",
      name: "genres",
      value: Array.isArray(EditpublicationData.genres)
        ? EditpublicationData.genres.map((genre) => genre.trim())
        : [],
      type: "multi-select",
      options: genresOptions.filter((option) => !EditpublicationData.genres.includes(option)),
    },
    {
      label: "Disclaimer",
      name: "disclaimer",
      value: Array.isArray(EditpublicationData.disclaimer) ? EditpublicationData.disclaimer : [],
      type: "multi-select",
      options: disclaimerOptions.filter(
        (option) => !EditpublicationData.disclaimer.includes(option)
      ),
    },
    {
      label: "Region",
      name: "modeType",
      type: "select",
      options: ["INDIA", "INTERNATIONAL"],
      value: EditpublicationData.modeType,
    },
    {
      label: "Indexed",
      name: "index2",
      value: EditpublicationData.index2,
      type: "radio",
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
        { label: "May Be", value: "maybe" },
      ],
    },
    {
      label: "Do Follow",
      name: "doFollow2",
      value: EditpublicationData.doFollow2,
      type: "radio",
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
        { label: "May Be", value: "maybe" },
      ],
    },
  ];

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected.");
      return;
    }
    const userName = localStorage.getItem("name");
    const currentDate = new Date().toISOString();

    console.log("📤 Uploading File:", file.name);
    console.log("File Size:", file.size, "bytes");
    console.log("Selection Mode:", selection);

    setOpenSnackbar(false);
    setUploading(true);

    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("lastmodifiedBy", userName);
      formData.append("lastUpdateDate", currentDate);
      formData.append("createdDate", currentDate);

      // 🔄 Dynamic API Route Selection based on current mode
      const apiUrl = selection === "package"
        ? "https://api.exampladmedia.com/api/publications/addBulkSocialMedia"
        : "https://api.exampladmedia.com/api/publications/addBulkPublication";

      console.log(`Hitting Target API Endpoint: ${apiUrl}`);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: sessionToken,
          // Content-Type manual set nahi karna hai, browser boundary automatically inject kar lega
        },
        body: formData,
      });

      const data = await response.json();

      if (response.status === 201 || response.status === 200) {

        // ---------------------------------------------------------
        // 1️⃣ SOCIAL MEDIA LOGIC (Only Alert, No Snackbar)
        // ---------------------------------------------------------
        if (selection === "package") {
          let alertMsg = data.message || "Bulk social media upload completed.";

          if (data.savedCount !== undefined || data.skippedCount !== undefined) {
            alertMsg += `\nSaved: ${data.savedCount || 0} | Skipped: ${data.skippedCount || 0}`;
          }

          if (data.skippedCount > 0 && data.skippedPackageNames?.length > 0) {
            const names = [];
            let reason = "SKIPPED";

            data.skippedPackageNames.forEach(item => {
              const match = item.match(/(.*?)\s*\((.*?)\)/);
              if (match) {
                names.push(match[1].trim());
                reason = match[2];
              } else {
                names.push(item);
              }
            });

            // Format: [testing, testing] = DUPLICATE_PACKAGE_NAME
            alertMsg += `\n\n[${names.join(", ")}] = ${reason}`;
          }

          setTimeout(() => {
            alert(alertMsg);
          }, 100);
        }
        // ---------------------------------------------------------
        // 2️⃣ PUBLICATION LOGIC (Original Snackbar Only)
        // ---------------------------------------------------------
        else {
          setSnackbarMessage(data.message || "Publication successfully uploaded!");
          setOpenSnackbar(true);
          setTimeout(() => setOpenSnackbar(false), 2000);
        }

        // Common execution for both
        if (Array.isArray(data)) {
          setRows(data);
        }
        fetchPublications();

      } else {
        console.error(`Upload failed: ${data.message || "Unknown error"}`);
        alert(`Upload failed: ${data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error in file upload process:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setUploading(false);
      if (event.target) {
        event.target.value = null;
      }
    }
  };

  // const handleFileUpload = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) {
  //     console.log("No file selected.");
  //     return;
  //   }
  //   const userName = localStorage.getItem("name");
  //   const currentDate = new Date().toISOString();

  //   console.log("📤 Uploading File:", file.name);
  //   console.log("File Size:", file.size, "bytes");
  //   console.log("Selection Mode:", selection);

  //   setOpenSnackbar(false);
  //   setUploading(true);
  //   try {
  //     const sessionToken = localStorage.getItem("sessionToken");
  //     if (!sessionToken) {
  //       console.error("Session token not found. Please log in again.");
  //       return;
  //     }
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     formData.append("lastmodifiedBy", userName);
  //     formData.append("lastUpdateDate", currentDate);
  //     formData.append("createdDate", currentDate);

  //     // 🔄 Dynamic API Route Selection based on current mode
  //     const apiUrl = selection === "package"
  //       ? "https://api.exampladmedia.com/api/publications/addBulkSocialMedia"
  //       : "https://api.exampladmedia.com/api/publications/addBulkPublication";

  //     console.log(`Hitting Target API Endpoint: ${apiUrl}`);

  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       headers: {
  //         Authorization: sessionToken,
  //         // Content-Type manual set nahi karna hai, browser boundary automatically inject kar lega
  //       },
  //       body: formData,
  //     });

  //     const data = await response.json();
  //     if (response.status === 201 || response.status === 200) {
  //       setSnackbarMessage(data.message || `${selection === "package" ? "Social Media" : "Publication"} successfully uploaded!`);
  //       setOpenSnackbar(true);
  //       setTimeout(() => setOpenSnackbar(false), 2000);
  //       if (Array.isArray(data)) {
  //         setRows(data);
  //       }
  //       fetchPublications();
  //     } else {
  //       console.error(`Upload failed: ${data.message || "Unknown error"}`);
  //       alert(`Upload failed: ${data.message || "Unknown error"}`);
  //     }
  //   } catch (error) {
  //     console.error("Error in file upload process:", error);
  //     alert(`Error: ${error.message}`);
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleBulkEditUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected.");
      return;
    }
    setOpenSnackbar(false);
    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data1 = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data1, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = jsonData[1] || [];
        const rows = jsonData.slice(2);

        const headerMap = {
          "ID": "id",
          "PUBLICATION": "publication",
          "PRICE": "orgPrice",
          "WORDS ALLOWED": "wordsAllowed",
          "BACKLINKS ALLOWED": "backlinksAllowed",
          "TAT": "tat",
          "INDEX2": "index2",
          "DOFOLLOW2": "doFollow2",
          "SAMPLE": "sample",
          "REGION": "modeType",
          "GENRES": "genres",
          "DISCLAIMER": "disclaimer",
          "USD PRICE": "usdPrice",
          "SPONSORED": "sponsored",
          "INDEXED": "indexed",
          "DOFOLLOW": "doFollow",
          "MARGIN PRICE": "marginPrice",
          "LAST MODIFIED NAME": "lastmodifiedBy",
          "CREATED DATE": "createdDate",
          "LAST MODIFIED DATE": "lastUpdateDate",
        };

        const publications = rows
          .map((row) => {
            const publication = {};
            headers.forEach((header, index) => {
              const field = headerMap[header.toUpperCase()];
              if (field) {
                if (field === "genres" || field === "disclaimer") {
                  publication[field] = row[index]
                    ? String(row[index]).split(",").map((item) => item.trim())
                    : [];
                } else if (field === "orgPrice" || field === "usdPrice" || field === "marginPrice") {
                  publication[field] = parseFloat(row[index]) || 0;
                } else if (field === "wordsAllowed") {
                  publication[field] = parseInt(row[index]) || 0;
                } else if (field === "sponsored" || field === "indexed" || field === "doFollow") {
                  publication[field] = row[index] === "Yes" || row[index] === true;
                } else if (field === "backlinksAllowed") {
                  publication[field] = String(row[index] || "");
                } else {
                  publication[field] = row[index] ? String(row[index]) : "";
                }
              }
            });
            return publication;
          })
          .filter((pub) => pub.id);

        const formattedPublications = publications.map((pub) => ({
          id: pub.id || "",
          userId: pub.id || "",
          publication: pub.publication || "",
          orgPrice: parseFloat(pub.orgPrice) || 0,
          marginPrice: parseFloat(pub.marginPrice) || 0,
          usdPrice: parseFloat(pub.usdPrice) || 0,
          wordsAllowed: parseInt(pub.wordsAllowed) || 0,
          backlinksAllowed: String(pub.backlinksAllowed || ""),
          tat: pub.tat || "",
          sponsored: pub.sponsored === true || pub.sponsored === "Yes",
          indexed: pub.indexed === true || pub.indexed === "Yes",
          doFollow: pub.doFollow === true || pub.doFollow === "Yes",
          genres: Array.isArray(pub.genres) ? pub.genres : [],
          disclaimer: Array.isArray(pub.disclaimer) ? pub.disclaimer : [],
          sample: pub.sample || "",
          modeType: pub.modeType || "",
          doFollow2: pub.doFollow2 || "No",
          index2: pub.index2 || "No",
          lastmodifiedBy: localStorage.getItem("name"),
          createdDate: pub.createdDate || "-",
          lastUpdateDate: new Date().toISOString()
        }));

        const sessionToken = localStorage.getItem("sessionToken");
        if (!sessionToken) {
          throw new Error("Session token not found. Please log in again.");
        }

        const response = await fetch("https://api.exampladmedia.com/api/publications/bulkEdit", {
          method: "PUT",
          headers: {
            Authorization: sessionToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedPublications),
        });

        const data = await response.json();
        if (response.ok) {
          setSnackbarMessage(data.message || "Publications updated successfully!");
          setOpenSnackbar(true);
          setTimeout(() => setOpenSnackbar(false), 2000);
          fetchPublications();
        } else {
          console.error(`Bulk edit failed: ${data.message || "Unknown error"}`);
          setSnackbarMessage(`Bulk edit failed: ${data.message || "Unknown error"}`);
          setOpenSnackbar(true);
        }
      };
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("Error in bulk edit upload:", error);
      setSnackbarMessage(`Error: ${error.message}`);
      setOpenSnackbar(true);
    } finally {
      setUploading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const toggleFilter = (filterKey) => {
    setFilters((prevFilters) => {
      const current = prevFilters[filterKey];
      let next;
      if (current === null) {
        next = "yes";
      } else if (current === "yes") {
        next = "no";
      } else if (current === "no") {
        next = "maybe";
      } else {
        next = null;
      }
      return { ...prevFilters, [filterKey]: next };
    });
  };

  const clearAllFilters = () => {
    setSelectedGenres([]);
    setSelectedDisclaimer([]);
    setFilters({
      index2: null,
      doFollow2: null,
      platformName: null,
    });
    setFiltersForMode({
      index2: "",
      modeType: "",
    });
    setPriceRange([sliderRange[0], sliderRange[1]]);
    setSortOption("default");
    // Trigger sort reset in DataTable
    setClearFilterTrigger(prev => prev + 1);
  };

  const handleEditPublication = async () => {
    const userRole = localStorage.getItem('userRole');
    const sessionToken = localStorage.getItem('sessionToken');

    if (!sessionToken) {
      setSnackbarMessage('Session token not found. Please log in again.');
      setOpenSnackbar(true);
      return;
    }

    setLoading(true);
    const apiUrl = `https://api.exampladmedia.com/api/publications/edit/${editId}`;
    const currentDate = new Date().toISOString();
    let fullPayload; // Declare here so it's accessible in catch block

    try {
      // हमेशा FULL PAYLOAD भेजो (Admin + Superadmin दोनों के लिए)
      fullPayload = {
        publication: EditpublicationData.publication,
        orgPrice: parseFloat(EditpublicationData.orgPrice) || 0,
        wordsAllowed: parseInt(EditpublicationData.wordsAllowed) || 0,
        backlinksAllowed: EditpublicationData.backlinksAllowed || 'yes',
        tat: EditpublicationData.tat || '',
        index2: EditpublicationData.index2 || 'no',
        indexed: EditpublicationData.indexed ?? true,
        doFollow: EditpublicationData.doFollow ?? true,
        doFollow2: EditpublicationData.doFollow2 || 'no',
        genres: Array.isArray(EditpublicationData.genres) ? EditpublicationData.genres : [],
        disclaimer: Array.isArray(EditpublicationData.disclaimer) ? EditpublicationData.disclaimer : [],
        sample: EditpublicationData.sample,
        daChecker: EditpublicationData.daChecker || '',
        trafficChecker: EditpublicationData.trafficChecker || '',
        modeType: EditpublicationData.modeType || '',
        packageName: EditpublicationData.packageName || '',
        lastUpdateDate: currentDate,
        lastmodifiedBy: localStorage.getItem('name') || ''
      };

      console.log('FULL Payload sent:', JSON.stringify(fullPayload, null, 2));

      const response = await axios.put(apiUrl, fullPayload, {
        headers: {
          'Authorization': sessionToken,
          'Content-Type': 'application/json'
        }
      });



      setSnackbarMessage(
        userRole === 'ADMIN'
          ? 'Sample updated successfully!'
          : 'Publication updated successfully!'
      );
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);

      fetchPublications();
      setEditId(null);

    } catch (error) {
      console.error('Error saving publication:', error.response?.data || error);
      console.error('Request payload was:', JSON.stringify(fullPayload, null, 2));
      setSnackbarMessage(`Error: ${error.response?.data?.message || 'Failed to save'}`);
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };




  const handleRangeChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  const selectRef = useRef(null);

  const handleArrowClick = (event) => {
    event.stopPropagation();
    if (selectRef.current) {
      selectRef.current.focus();
      selectRef.current.click();
    }
  };

  const parseDate = (dateString) => {
    if (!dateString || dateString === "-") {
      console.warn(`Invalid or missing date: ${dateString}`);
      return null;
    }

    const parsedDayjs = dayjs(dateString, [
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
      "YYYY-MM-DDTHH:mm:ssZ",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DD",
      "MM/DD/YYYY HH:mm:ss",
      "MM/DD/YYYY",
    ], true);

    if (parsedDayjs.isValid()) {
      return parsedDayjs.toDate();
    }

    const parsed = new Date(dateString);
    if (!isNaN(parsed)) {
      return parsed;
    }

    console.error(`Failed to parse date: ${dateString}`);
    return null;
  };

  const filteredRows = useMemo(() => {
    let filtered = rows;


    if (selection === "package") {
      filtered = filtered.filter(row => Boolean(row.packageName));
    } else if (selection === "publication") {
      filtered = filtered.filter(row => !row.packageName);
    }

    filtered = filtered.filter((row) => {
      const matchesIndexed =
        filters.index2 === null || row.index2?.toLowerCase() === filters.index2.toLowerCase();
      const matchesModeType =
        filtersForMode.modeType === '' || row.modeType === filtersForMode.modeType;
      // return matchesIndexed && matchesModeType;
      const matchesPlatform = !filters.platformName ||
        (row.platformName &&
          String(row.platformName).trim().toLowerCase() === String(filters.platformName).trim().toLowerCase());

      return matchesIndexed && matchesModeType && matchesPlatform;
      // });
    });

    if (
      Object.values(filters).every((value) => value === null) &&
      priceRange[0] === sliderRange[0] &&
      priceRange[1] === sliderRange[1]
    ) {
      filtered = filtered;
    } else {
      filtered = filtered.filter((row) => {
        const gstPrice = parseFloat(row.gstPrice) || 0;
        const withinRange = gstPrice >= priceRange[0] && gstPrice <= priceRange[1];
        const matchesFilters = Object.entries(filters).every(([key, value]) => {
          if (value === null || key === "platformName") return true;
          return row[key]?.toLowerCase() === value.toLowerCase();
        });
        return withinRange && matchesFilters;
      });
    }

    filtered = filterRows(filtered);

    filtered.sort((a, b) => {
      switch (sortOption) {
        case "price_asc":
          return (parseFloat(a.gstPrice) || 0) - (parseFloat(b.gstPrice) || 0);
        case "price_desc":
          return (parseFloat(b.gstPrice) || 0) - (parseFloat(a.gstPrice) || 0);
        case "newly_added":
          const parsedACreated = parseDate(a.createdDate);
          const parsedBCreated = parseDate(b.createdDate);
          if (!parsedACreated && !parsedBCreated) return 0;
          if (!parsedACreated) return 1;
          if (!parsedBCreated) return -1;
          return parsedBCreated - parsedACreated;
        case "recently_modified":
          const parsedAModified = parseDate(a.lastmodifiedDate || a.createdDate);
          const parsedBModified = parseDate(b.lastmodifiedDate || b.createdDate);
          if (!parsedAModified && !parsedBModified) return 0;
          if (!parsedAModified) return 1;
          if (!parsedBModified) return -1;
          return parsedBModified - parsedAModified;
        case "default":
        default:
          // 1. Primary Sort: INDIA first
          if (a.modeType === "INDIA" && b.modeType !== "INDIA") return -1;
          if (a.modeType !== "INDIA" && b.modeType === "INDIA") return 1;

          const timeA = a.lastmodifiedDate !== "-" ? dayjs(a.lastmodifiedDate).valueOf() : 0;
          const timeB = b.lastmodifiedDate !== "-" ? dayjs(b.lastmodifiedDate).valueOf() : 0;

          return timeB - timeA; // Higher value (newest) upar aayega
      }
    });

    return filtered;
  }, [rows, filters, priceRange, sliderRange, selectedGenres, selectedDisclaimer, filtersForMode, sortOption]);

  useEffect(() => {
    setLoading(true);
    setRows(fetchedRows);
    setLoading(false);
  }, [fetchedRows]);

  const handleDownloadExcel = () => {

    const userRole = localStorage.getItem("userRole");
    const isClient = userRole === "CLIENT";
    const isBUSINESS = userRole === "BUSINESS_TEAM";

    try {
      const selectedRows =
        selected.length > 0
          ? filteredRows.filter(row =>
            selected.includes(
              selection === "package" ? row.packageName : row.userId
            )
          )
          : filteredRows;

      if (!selectedRows || selectedRows.length === 0) {
        console.warn("No data available to download!");
        return;
      }

      const wb = XLSX.utils.book_new();
      const currentDate = new Date();
      const formattedDate = `${String(currentDate.getMonth() + 1).padStart(2, "0")}${String(
        currentDate.getDate()
      ).padStart(2, "0")}${currentDate.getFullYear()}${String(
        currentDate.getHours()
      ).padStart(2, "0")}${String(currentDate.getMinutes()).padStart(2, "0")}`;

      const headerRow1 = ["Download", formattedDate];

      /* ================= HEADERS ================= */
      const baseHeaders =
        selection === "package"
          ? [
            "PUBLICATION NAME",
            "Platform",
            "PRICE",
            "USD PRICE",
            "TAT",
            "GENRES",
            "COLLAB",
            "SAMPLE",
          ]
          : [
            // "ID",
            "PUBLICATION",
            "PRICE",
            "USD PRICE",
            // "MARGIN PRICE",
            "WORDS ALLOWED",
            "BACKLINKS ALLOWED",
            "TAT",
            "SPONSORED",
            "INDEXED",
            "DOFOLLOW",
            "GENRES",
            "DISCLAIMER",
            "SAMPLE",
            "REGION",
          ];

      const auditHeaders = isClient || isBUSINESS
        ? ["LAST MODIFIED DATE"]
        : ["LAST MODIFIED NAME", "CREATED DATE", "LAST MODIFIED DATE"];

      const headerRow2 = [...baseHeaders, ...auditHeaders];

      /* ================= EXPAND PUBLICATIONS ================= */
      const expandedRows = [];

      selectedRows.forEach(row => {
        if (Array.isArray(row.publications) && row.publications.length > 0) {
          row.publications.forEach(pub => {
            expandedRows.push({
              ...row,
              publicationText: pub.props?.children || row.publicationText || "",
              sample: pub.props?.href || pub.props?.children || row.sample || "",
            });
          });
        } else {
          expandedRows.push({
            ...row,
            publicationText: row.publicationText || "",
            sample: row.sample || "",
          });
        }
      });

      let dataRows = [];
      let merges = [];
      let currentRowIndex = 2;

      /* ================= PACKAGE MODE ================= */
      if (selection === "package") {



        const groupedData = {};
        expandedRows.forEach(row => {
          if (!groupedData[row.packageName]) groupedData[row.packageName] = [];
          groupedData[row.packageName].push(row);
        });
        console.log(groupedData)
        Object.keys(groupedData).forEach(packageName => {
          const rows = groupedData[packageName];
          const groupStartIndex = currentRowIndex;

          const tempArr = []
          rows.forEach(row => {
            const isPresent = tempArr.filter(item => item.userId === row.userId)
            if (!isPresent.length) {
              tempArr.push(row)
            }
          })

          tempArr.forEach((row, index) => {

            console.log('sample row', row);

            const publicationName =
              Array.isArray(row.publicationNames) ? row.publicationNames[index] || "" : "";

            const sampleUrl =
              Array.isArray(row.sampleUrls) ? row.sampleUrls[index] || "" : "";

            const genres =
              Array.isArray(row.genres) ? row.genres.join(", ") : row.genres || "";

            const disclaimer =
              Array.isArray(row.disclaimer)
                ? row.disclaimer.join(", ")
                : row.disclaimer || "";

            var maxLength = row.publicationNames.length
            if (maxLength < row.sampleUrls.length) maxLength = row.sampleUrls.length

            for (let index = 0; index < maxLength; index++) {
              const baseRow = [
                // index === 0 ? row.packageName : "",
                // index === 0 ? row.platformName : "",
                // index === 0 ? row.gstPrice : "",
                // index === 0 ? row.usdPrice : "",
                // index === 0 ? row.collab : "",
                // index === 0 ? genres : "",
                // row.sampleUrls[0],
                index === 0 ? row.packageName : "",
                index === 0 ? row.platformName : "",
                index === 0 ? row.gstPrice : "",
                index === 0 ? row.usdPrice : "",
                index === 0 ? row.tat : "",              // ✅ TAT add karo
                index === 0 ? genres : "",
                index === 0 ? row.collab : "",           // ✅ Collab correct position
                index === 0 ? row.sampleUrls[0] : "",
              ];

              const auditRow = isClient || isBUSINESS
                ? [
                  row.lastmodifiedDate
                    ? dayjs(row.lastmodifiedDate).format("DD-MMM-YYYY")
                    : "-"
                ]
                : [
                  row.lastmodifiedBy || "-",
                  row.createdDate
                    ? dayjs(row.createdDate).format("DD-MMM-YYYY")
                    : "-",
                  row.lastmodifiedDate
                    ? dayjs(row.lastmodifiedDate).format("DD-MMM-YYYY")
                    : "-"
                ];


              dataRows.push([...baseRow, ...auditRow]);

            }


            currentRowIndex++;
          });

          // const mergeCols = isClient || isBUSINESS
          //   ? [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15]
          //   : [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17];

          const mergeCols = isClient || isBUSINESS
            ? [0, 1, 2, 3, 4, 5, 6]     // without audit extras
            : [0, 1, 2, 3, 4, 5, 6, 8, 9, 10];

          mergeCols.forEach(col => {
            merges.push({
              s: { r: groupStartIndex, c: col },
              e: { r: currentRowIndex - 1, c: col },
            });
          });
        });
      }

      else {
        /* ================= NON PACKAGE ================= */
        expandedRows.forEach(row => {
          const baseRow = [
            // row.userId || "",
            row.publicationText || "",
            row.gstPrice || "",
            row.usdPrice || "",
            // row.marginPrice || "",
            row.wordsAllowed || "",
            row.backlinksAllowed || "",
            row.tat || "",
            row.sponsored || "",
            row.index2 || "",
            row.doFollow2 || "",
            row.genres || "",
            row.disclaimer || "",
            row.sample?.props?.href || row.sample || "",
            row.modeType || "",
          ];

          // const auditRow = isClient
          //   ? [row.lastmodifiedDate || ""]
          //   : [
          //     row.lastmodifiedBy || "",
          //     row.createdDate || "",
          //     row.lastmodifiedDate || "",
          //   ];

          const auditRow = isClient || isBUSINESS
            ? [
              row.lastmodifiedDate
                ? dayjs(row.lastmodifiedDate).format("DD-MMM-YYYY")
                : "-"
            ]
            : [
              row.lastmodifiedBy || "-",
              row.createdDate
                ? dayjs(row.createdDate).format("DD-MMM-YYYY")
                : "-",
              row.lastmodifiedDate
                ? dayjs(row.lastmodifiedDate).format("DD-MMM-YYYY")
                : "-"
            ];


          dataRows.push([...baseRow, ...auditRow]);
        });
      }

      const finalData = [headerRow1, headerRow2, ...dataRows];
      const ws = XLSX.utils.aoa_to_sheet(finalData);
      ws["!cols"] = headerRow2.map(() => ({ width: 18 }));
      ws["!merges"] = merges;

      XLSX.utils.book_append_sheet(
        wb,
        ws,
        selection === "package" ? "Social Media" : "Publications"
      );

      XLSX.writeFile(
        wb,
        selection === "package"
          ? `Social Media_${formattedDate}.xlsx`
          : `publications_${formattedDate}.xlsx`
      );

      console.log("Excel generated successfully ✅");
    } catch (error) {
      console.error("Excel error:", error);
    }
  };

  const handleConfirmDeletePackage = async (item) => {
    setPackagePublicationIds(item);
    setdeletePackageBox(true);
  };

  const handleConfirmDelete = async (item) => {
    setdeleteId(item);
    setdeleteBox(true);
  };

  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      const response = await axios.delete(
        `https://api.exampladmedia.com/api/publications/remove/${deleteId}`,
        {
          headers: {
            Authorization: sessionToken,
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Publication deleted successfully!");
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        setdeleteBox(false);
        fetchPublications();
      }
    } catch (error) {
      console.error("Error deleting publication:", error);
      setSnackbarMessage("Failed to delete publication. Please try again.");
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
      setdeleteBox(false);
    }
  };

  const handleDeletePackage = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      const response = await axios.delete(
        `https://api.exampladmedia.com/api/publications/removePackage`,
        {
          headers: {
            Authorization: sessionToken,
            "Content-Type": "application/json",
          },
          data: [packagePublicationIds],
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Social Media deleted successfully!");
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        setdeletePackageBox(false);
        setPackagePublicationIds([]);
        fetchPublications();
      }
    } catch (error) {
      console.error("Error deleting Social Media:", error);
      setSnackbarMessage("Failed to delete Social Media. Please try again.");
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
      setdeletePackageBox(false);
    }
  };



  const pubRows = !!fetchedRows?.length
    ? fetchedRows.forEach((row) => {
      row.action = (
        <MDBox
          display="flex"
          flexWrap="wrap"
          gap={1}
          alignItems="center"
          justifyContent={{ xs: "center", sm: "flex-start" }}
          width={{ xs: "100%", sm: "auto" }}
          sx={{ position: "relative", top: "-10px" }}
        >
          {userRole === "SUPER_ADMIN" && (
            <>
              <IconButton
                color="primary"
                onClick={() => {
                  console.log("Enable edit", row);
                  if (row.packageName) {
                    // setEditId(row.userId);
                    setPublicationData({
                      orgPrice: row.orgPrice || "",
                      wordsAllowed: row.wordsAllowed || "",
                      backlinksAllowed: row.backlinksAllowed || "",
                      tat: row.tat || "",
                      index2: (row.index2 || "no").toLowerCase(),
                      doFollow2: (row.doFollow2 || "no").toLowerCase(),
                      genres: Array.isArray(row.genres)
                        ? row.genres
                        : row.genres
                          ? row.genres.split(",").map((genre) => genre.trim())
                          : [],
                      disclaimer: Array.isArray(row.disclaimer)
                        ? row.disclaimer
                        : row.disclaimer
                          ? row.disclaimer.split(",").map((disc) => disc.trim())
                          : [],
                      modeType: row.modeType || "",
                      packageName: row.packageName || "",
                      platformName: row.platformName || "", // Platform load karne ke liye
                      collab: (row.collab || "no").toLowerCase(), // Collab radio ke liye
                      sample: Array.isArray(row.sampleUrls) ? row.sampleUrls[0] : (row.sample || ""), // Sample input ke liye
                      indexed: true,
                      doFollow: true,
                      packageId: row.userId
                    });

                    const pubList = fetchedRows
                      .filter(r => r.packageName === row.packageName)   // same package ke sab rows
                      .flatMap(r =>
                        (r.publicationNames || []).map((name, index) => ({
                          name,
                          link: r.sampleUrls?.[index] || "",
                          id: r.userId || null,
                        }))
                      );
                    console.log("Publication list:", pubList);
                    setPublicationList(pubList);
                    setOriginalPublicationList(pubList.map((p) => ({ ...p })));
                    setPackages(true);
                    setIsEdit(true);
                    setIsModalOpen(true);
                    // Do NOT set editId for packages
                  } else {
                    setEditId(row.userId);
                    setEditPublicationData({
                      publication: row.publicationText || "",
                      orgPrice: row.orgPrice || "",
                      wordsAllowed: row.wordsAllowed || "",
                      backlinksAllowed: row.backlinksAllowed || "",
                      tat: row.tat || "",
                      index2: (row.index2 || "no").toLowerCase(),
                      indexed: true,
                      doFollow: true,
                      doFollow2: (row.doFollow2 || "no").toLowerCase(),
                      genres: Array.isArray(row.genres)
                        ? row.genres
                        : row.genres
                          ? row.genres.split(",").map((genre) => genre.trim())
                          : [],
                      disclaimer: Array.isArray(row.disclaimer)
                        ? row.disclaimer
                        : row.disclaimer
                          ? row.disclaimer.split(",").map((disc) => disc.trim())
                          : [],
                      sample: row.sample?.props?.href || "",
                      daChecker: row.daChecker?.props?.href || "",
                      trafficChecker: row.trafficChecker?.props?.href || "",
                      modeType: row.modeType || "",
                    });
                    setIsModalOpen(false); // Ensure main Dialog is closed
                  }
                }}
              >
                <EditIcon style={{ color: "green" }} />
              </IconButton>
              <IconButton
                color="secondary"
                onClick={() =>
                  selection === "package"
                    ? handleConfirmDeletePackage(row.packageName)
                    : handleConfirmDelete(row.userId)
                }
              >
                <DeleteIcon style={{ color: "red" }} />
              </IconButton>
            </>
          )}
          {userRole === "ADMIN" && selection === "package" && (
            <>
              {/* <IconButton
                color="primary"
                onClick={() => {
                  console.log("Enable edit", row);
                  if (row.packageName) {
                    // setEditId(row.userId);
                    setPublicationData({
                      orgPrice: row.orgPrice || "",
                      wordsAllowed: row.wordsAllowed || "",
                      backlinksAllowed: row.backlinksAllowed || "",
                      tat: row.tat || "",
                      index2: (row.index2 || "no").toLowerCase(),
                      doFollow2: (row.doFollow2 || "no").toLowerCase(),
                      genres: Array.isArray(row.genres)
                        ? row.genres
                        : row.genres
                          ? row.genres.split(",").map((genre) => genre.trim())
                          : [],
                      disclaimer: Array.isArray(row.disclaimer)
                        ? row.disclaimer
                        : row.disclaimer
                          ? row.disclaimer.split(",").map((disc) => disc.trim())
                          : [],
                      modeType: row.modeType || "",
                      packageName: row.packageName || "",
                      indexed: true,
                      doFollow: true,
                    });

                    // const pubList = (row.publications || []).map((pub, index) => ({
                    //   name: pub.props?.children || `Publication ${index + 1}`,
                    //   link: pub.props?.href || "",
                    //   id: row.userId || null,
                    // }));

                    // console.log('etchrows',fetchedRows);


                    const pubList = fetchedRows
                      .filter(r => r.packageName === row.packageName)   // same package ke sab rows
                      .flatMap(r =>
                        (r.publicationNames || []).map((name, index) => ({
                          name,
                          link: r.sampleUrls?.[index] || "",
                          id: r.userId || null,
                        }))
                      );
                    console.log("Publication list:", pubList);
                    setPublicationList(pubList);
                    setOriginalPublicationList(pubList.map((p) => ({ ...p })));
                    setPackages(true);
                    setIsEdit(true);
                    // setIsModalOpen(true);
                    // Do NOT set editId for packages
                  } else {
                    setEditId(row.userId);
                    setEditPublicationData({
                      publication: row.publicationText || "",
                      orgPrice: row.orgPrice || "",
                      wordsAllowed: row.wordsAllowed || "",
                      backlinksAllowed: row.backlinksAllowed || "",
                      tat: row.tat || "",
                      index2: (row.index2 || "no").toLowerCase(),
                      indexed: true,
                      doFollow: true,
                      doFollow2: (row.doFollow2 || "no").toLowerCase(),
                      genres: Array.isArray(row.genres)
                        ? row.genres
                        : row.genres
                          ? row.genres.split(",").map((genre) => genre.trim())
                          : [],
                      disclaimer: Array.isArray(row.disclaimer)
                        ? row.disclaimer
                        : row.disclaimer
                          ? row.disclaimer.split(",").map((disc) => disc.trim())
                          : [],
                      sample: row.sample?.props?.href || "",
                      daChecker: row.daChecker?.props?.href || "",
                      trafficChecker: row.trafficChecker?.props?.href || "",
                      modeType: row.modeType || "",
                    });
                    setIsModalOpen(false); // Ensure main Dialog is closed
                  }
                }}
              >
                <EditIcon style={{ color: "green" }} />
              </IconButton> */}
              <IconButton
                color="primary"
                onClick={() => {
                  console.log("Enable edit", row);
                  if (row.packageName) {
                    // setEditId(row.userId);
                    setPublicationData({
                      ...publicationData,
                      orgPrice: row.orgPrice || "",
                      wordsAllowed: row.wordsAllowed || "",
                      backlinksAllowed: row.backlinksAllowed || "",
                      tat: row.tat || "",
                      index2: (row.index2 || "no").toLowerCase(),
                      doFollow2: (row.doFollow2 || "no").toLowerCase(),
                      genres: Array.isArray(row.genres)
                        ? row.genres
                        : row.genres
                          ? row.genres.split(",").map((genre) => genre.trim())
                          : [],
                      disclaimer: Array.isArray(row.disclaimer)
                        ? row.disclaimer
                        : row.disclaimer
                          ? row.disclaimer.split(",").map((disc) => disc.trim())
                          : [],
                      modeType: row.modeType || "",
                      packageName: row.packageName || "",
                      platformName: row.platformName || "", // Platform load karne ke liye
                      collab: (row.collab || "no").toLowerCase(), // Collab radio ke liye
                      sample: Array.isArray(row.sampleUrls) ? row.sampleUrls[0] : (row.sample || ""), // Sample input ke liye
                      indexed: true,
                      doFollow: true,
                      packageId: row.userId
                    });

                    const pubList = fetchedRows
                      .filter(r => r.packageName === row.packageName)   // same package ke sab rows
                      .flatMap(r =>
                        (r.publicationNames || []).map((name, index) => ({
                          name,
                          link: r.sampleUrls?.[index] || "",
                          id: r.userId || null,
                        }))
                      );
                    console.log("Publication list:", pubList);
                    setPublicationList(pubList);
                    setOriginalPublicationList(pubList.map((p) => ({ ...p })));
                    setPackages(true);
                    setIsEdit(true);
                    setIsModalOpen(true);
                    // Do NOT set editId for packages
                  } else {
                    setEditId(row.userId);
                    setEditPublicationData({
                      publication: row.publicationText || "",
                      orgPrice: row.orgPrice || "",
                      wordsAllowed: row.wordsAllowed || "",
                      backlinksAllowed: row.backlinksAllowed || "",
                      tat: row.tat || "",
                      index2: (row.index2 || "no").toLowerCase(),
                      indexed: true,
                      doFollow: true,
                      doFollow2: (row.doFollow2 || "no").toLowerCase(),
                      genres: Array.isArray(row.genres)
                        ? row.genres
                        : row.genres
                          ? row.genres.split(",").map((genre) => genre.trim())
                          : [],
                      disclaimer: Array.isArray(row.disclaimer)
                        ? row.disclaimer
                        : row.disclaimer
                          ? row.disclaimer.split(",").map((disc) => disc.trim())
                          : [],
                      sample: row.sample?.props?.href || "",
                      daChecker: row.daChecker?.props?.href || "",
                      trafficChecker: row.trafficChecker?.props?.href || "",
                      modeType: row.modeType || "",
                    });
                    setIsModalOpen(false); // Ensure main Dialog is closed
                  }
                }}
              >
                <EditIcon style={{ color: "green" }} />
              </IconButton>
            </>
          )}
          {userRole === 'ADMIN' && selection !== "package" && (
            <IconButton
              color="primary"
              onClick={() => {
                setEditId(row.userId);
                // सभी data load करो, लेकिन सिर्फ sample editable रहेगा
                setEditPublicationData({
                  publication: row.publicationText,
                  orgPrice: row.orgPrice,
                  wordsAllowed: row.wordsAllowed,
                  backlinksAllowed: row.backlinksAllowed,
                  tat: row.tat,
                  index2: row.index2?.toLowerCase() || 'no',
                  indexed: true,
                  doFollow: true,
                  doFollow2: row.doFollow2?.toLowerCase() || 'no',
                  genres: Array.isArray(row.genres) ? row.genres : (row.genres ? row.genres.split(',').map(g => g.trim()) : []),
                  disclaimer: Array.isArray(row.disclaimer) ? row.disclaimer : (row.disclaimer ? row.disclaimer.split(',').map(d => d.trim()) : []),
                  sample: row.sample?.props?.href || '',  // सिर्फ यही editable
                  daChecker: row.daChecker?.props?.href || '',
                  trafficChecker: row.trafficChecker?.props?.href || '',
                  modeType: row.modeType
                });
                setIsModalOpen(false);
              }}
            >
              <EditIcon style={{ color: 'green' }} />
            </IconButton>
          )}



        </MDBox>
      );
    })
    : [];
  console.log("pubrows", pubRows);


  const handleDeleteCancel = () => {
    setdeleteBox(false);
  };
  const handleDeleteCancelPackage = () => {
    setdeletePackageBox(false);
  };

  const CustomerSearch = () => {
    const isAdminOrBusiness =
      userRole === "BUSINESS_TEAM" || userRole === "ADMIN";

    const options = isAdminOrBusiness ? rowss : customers;

    return (
      <Autocomplete
        options={options}

        filterOptions={(options, { inputValue }) => {
          const search = inputValue.trim().toLowerCase();

          if (!search) return options;

          return options.filter((option) =>
            option.name?.toLowerCase().startsWith(search)
          );
        }}

        getOptionLabel={(option) =>
          option?.name
            ? `${option.name}${option.margin ? ` - ${option.margin} Rs` : ""}`
            : ""
        }

        // ✅ VERY IMPORTANT
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
            {option.margin ? ` - ${option.margin} Rs` : ""}
          </li>
        )}

        isOptionEqualToValue={(option, value) =>
          option?.id === value?.id
        }

        value={selectedCustomer || null}

        onChange={(event, newValue) => {
          setSelectedCustomer(newValue || null);

          if (newValue) {
            const userId =
              userRole === "BUSINESS_TEAM" || userRole === "ADMIN"
                ? newValue.userId || newValue.id
                : newValue.userId;

            fetchCustomerPublications(userId);
          } else {
            fetchPublications();
          }
        }}

        size="small"
        style={{ width: 200 }}

        renderInput={(params) => (
          <TextField
            {...params}
            label="Search for customer"
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <SearchIcon fontSize="small" sx={{ color: "#9aa0a6", mr: 0.5 }} />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        )}
      />


    );
  };



  useEffect(() => {
    fetchRegions();
    setShowContent(true);
    const popupStatus = localStorage.getItem("popupShown");
    if (popupStatus === "false") {
      setOpenPopup(true);
      localStorage.setItem("popupShown", "true");
    }
  }, []);

  const handleClose = () => {
    setOpenPopup(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("popupShown");
    handleSignOut();
  };

  const handleSliderChange = (event, newValue) => {
    setPriceRange(newValue);
    setMinInput(newValue[0]);
    setMaxInput(newValue[1]);
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setPublicationInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddPublication = () => {
    if (publicationInput.name.trim()) {
      setPublicationList([
        ...publicationList,
        { name: publicationInput.name, link: publicationInput.link || "", id: null },
      ]);
      setPublicationInput({ name: "", link: "" });
    }
  };


  const handleRemovePublication = (indexToRemove) => {
    setPublicationList(publicationList.filter((_, index) => index !== indexToRemove));
  };

  const handleAddPackagesClick = () => {
    setPackages(true);
  };

  const handleOpenFilterModal = () => {
    setIsFilterModalOpen(true);
  };

  const handleCloseFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  const currentUserRole = localStorage.getItem("userRole");

  useEffect(() => {
    const fetchUsersBusiness = async () => {
      console.log('called');
      setLoading(true);

      try {
        const sessionToken = localStorage.getItem("sessionToken");
        const userId = localStorage.getItem("ueserId");

        if (!sessionToken) {
          console.error("Session token not found. Please log in again.");
          return;
        }

        const response = await axios.get(
          `https://api.exampladmedia.com/auth/getUsers/${userId}`,
          {
            headers: {
              Authorization: sessionToken,
            },
          }
        );

        const userRows = response.data
          .filter((user) => user.userRole !== "SUPER_ADMIN")
          .map((user) => ({
            name: user.name,
            margin: user.margin || "-",
            userId: user.userId,
          }));

        setRowss(userRows);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        console.log(false);
      }
    };

    if (currentUserRole === 'BUSINESS_TEAM' || currentUserRole === 'ADMIN') {
      fetchUsersBusiness();
    }
  }, [currentUserRole]);

  const isPackage = selection === "package";

  const [selected, setSelected] = useState([]);

  const [bulkEditOpen, setBulkEditOpen] = useState(false);

  const [bulkData, setBulkData] = useState({
    orgPrice: "",
    wordsAllowed: "",
    backlinksAllowed: "",
    tat: "",
    sample: "",
    daChecker: "",
    trafficChecker: "",
    modeType: "",
  });

  const handleSelect = (row) => {
    const rowId = isPackage ? row.packageName : row.userId;
    setSelected((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  const handleSelectAll = () => {
    const allIds = filteredRows.map((row) => (isPackage ? row.packageName : row.userId));

    setSelected((prevSelected) => {
      const allSelected = allIds.every((id) => prevSelected.includes(id));
      if (allSelected) {
        return prevSelected.filter((id) => !allIds.includes(id));
      } else {
        return Array.from(new Set([...prevSelected, ...allIds]));
      }
    });
  };

  const handleBulkDelete = async () => {
    if (selected.length === 0) return;

    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${selected.length} item(s)?`
    );
    if (!confirmDelete) return;

    setLoading(true);

    try {
      const sessionToken = localStorage.getItem("sessionToken");

      const apiUrl = "https://api.exampladmedia.com/api/publications/bulkDelete";
      const apiMethod = "delete";

      await axios.request({
        url: apiUrl,
        method: apiMethod,
        data: selected,
        headers: {
          Authorization: sessionToken,
          "Content-Type": "application/json",
        },
      });

      setSnackbarMessage(
        isPackage
          ? "Selected packages deleted successfully!"
          : "Selected publications deleted successfully!"
      );
      setOpenSnackbar(true);

      await fetchPublications();
      setSelected([]);
    } catch (error) {
      console.error("Error deleting items:", error);
      setSnackbarMessage("Failed to delete selected items. Please try again.");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkEdit = () => {
    if (isPackage) {
      setSnackbarMessage("Bulk edit not supported for packages");
      setOpenSnackbar(true);
      return;
    }
    if (selected.length === 0) return;
    setBulkEditOpen(true);
  };

  const handleBulkInputChange = (e) => {
    const { name, value } = e.target;
    setBulkData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveBulkEdit = async () => {
    setLoading(true);
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      const lastUpdateDate = new Date().toISOString();
      const lastmodifiedBy = localStorage.getItem("name");

      await Promise.all(
        selected.map(async (id) => {
          const updatedFields = {};
          Object.entries(bulkData).forEach(([key, value]) => {
            if (value !== "") {
              updatedFields[key] = key === "orgPrice" || key === "wordsAllowed"
                ? parseFloat(value) || 0
                : key === "backlinksAllowed"
                  ? parseInt(value) || 0
                  : value;
            }
          });
          if (Object.keys(updatedFields).length > 0) {
            await axios.put(
              `https://api.exampladmedia.com/api/publications/edit/${id}`,
              {
                ...updatedFields,
                lastUpdateDate,
                lastmodifiedBy,
              },
              {
                headers: {
                  Authorization: sessionToken,
                  "Content-Type": "application/json",
                },
              }
            );
          }
        })
      );

      setSnackbarMessage("Bulk update successful!");
      setOpenSnackbar(true);
      setBulkEditOpen(false);
      setBulkData({
        orgPrice: "",
        wordsAllowed: "",
        backlinksAllowed: "",
        tat: "",
        sample: "",
        daChecker: "",
        trafficChecker: "",
        modeType: "",
      });
      fetchPublications();
      setSelected([]);
    } catch (error) {
      console.error("Error in bulk edit:", error);
      setSnackbarMessage("Failed to perform bulk edit.");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseBulkEdit = () => {
    setBulkEditOpen(false);
    setBulkData({
      orgPrice: "",
      wordsAllowed: "",
      backlinksAllowed: "",
      tat: "",
      sample: "",
      daChecker: "",
      trafficChecker: "",
      modeType: "",
    });
  };

  const modifiedColumns = useMemo(() => {
    if (userRole === "SUPER_ADMIN" && !isPackage) {
      return [
        {
          Header: (
            <Checkbox
              checked={filteredRows.length > 0 && selected.length === filteredRows.length}
              indeterminate={selected.length > 0 && selected.length < filteredRows.length}
              onChange={handleSelectAll}
            />
          ),
          accessor: "select",
          align: "center",
          sortable: false,
        },
        ...columns,
      ];
    }

    return columns;

  }, [filteredRows.length, selected.length, columns]);

  const isRowSelected = (row) => {
    const rowId = isPackage ? row.packageName : row.userId;
    return selected.includes(rowId);
  };

  const modifiedRows = useMemo(() => {
    return filteredRows.map((row) => {
      const rowId = isPackage ? row.packageName : row.userId;
      return {
        ...row,
        select: (
          <Checkbox
            key={rowId}
            checked={isRowSelected(row)}
            onChange={() => handleSelect(row)}
          />
        ),
      };
    });
  }, [filteredRows, selected, isPackage]);

  const adminFields = userRole === 'ADMIN'
    ? fields.filter(field => field.name === 'sample')
    : fields;

  const displayedRows = selectedCustomer ? rows : modifiedRows;

  // If SUPER_ADMIN, add checkboxes to displayed rows if not already present
  const finalRows = userRole === "SUPER_ADMIN" && !isPackage ? displayedRows.map((row) => {
    const rowId = isPackage ? row.packageName : row.userId;
    return {
      ...row,
      select: row.select || (
        <Checkbox
          key={rowId}
          checked={isRowSelected(row)}
          onChange={() => handleSelect(row)}
        />
      ),
    };
  }) : displayedRows;

  // 📱 Mobile-only derived data for the Publication List (desktop DataTable is untouched)
  const mobileSortOptions = [
    { value: "default", label: "Default" },
    { value: "price_asc", label: "Price: Low to High" },
    { value: "price_desc", label: "Price: High to Low" },
    { value: "newly_added", label: "Newly Added" },
    { value: "recently_modified", label: "Recently Modified" },
  ];

  const mobileFilteredRows = useMemo(() => {
    const term = mobileSearchTerm.trim().toLowerCase();
    if (!term) return finalRows;
    return finalRows.filter((row) => {
      const pub = String(row.publicationText || row.packageName || "").toLowerCase();
      const genre = String(row.genres || "").toLowerCase();
      return pub.includes(term) || genre.includes(term);
    });
  }, [finalRows, mobileSearchTerm]);

  const mobileTotalPages = Math.max(1, Math.ceil(mobileFilteredRows.length / mobileRowsPerPage));

  const mobilePageRows = useMemo(() => {
    const start = mobilePage * mobileRowsPerPage;
    return mobileFilteredRows.slice(start, start + mobileRowsPerPage);
  }, [mobileFilteredRows, mobilePage, mobileRowsPerPage]);

  const mobileEntriesStart = mobileFilteredRows.length === 0 ? 0 : mobilePage * mobileRowsPerPage + 1;
  const mobileEntriesEnd = Math.min((mobilePage + 1) * mobileRowsPerPage, mobileFilteredRows.length);

  useEffect(() => {
    setMobilePage(0);
  }, [mobileSearchTerm, mobileRowsPerPage, selection, finalRows.length]);

  // 📱 Mobile-only: column widths for the horizontally scrollable table.
  // Uses the SAME columns (modifiedColumns) the desktop DataTable renders, so the
  // mobile view always shows the identical set of columns as desktop.
  const getMobileColWidth = (accessor) => {
    const widthMap = {
      select: 44,
      publication: 170,
      packageName: 170,
      gstPrice: 90,
      usdPrice: 90,
      wordsAllowed: 100,
      backlinksAllowed: 100,
      tat: 70,
      index2: 90,
      doFollow2: 90,
      genres: 130,
      collab: 90,
      sample: 80,
      disclaimer: 130,
      modeType: 90,
      daChecker: 90,
      trafficChecker: 90,
      lastmodifiedBy: 120,
      createdDate: 110,
      lastmodifiedDate: 120,
      action: 100,
    };
    return widthMap[accessor] || 110;
  };

  const renderMobileCellValue = (col, row) => {
    const raw = row[col.accessor];
    if (col.Cell) {
      try {
        return col.Cell({ value: raw });
      } catch (e) {
        return raw;
      }
    }
    return raw;
  };

  const isAdmin = userRole === "ADMIN";
  const isSuper = userRole === "SUPER_ADMIN";

  const activeFields = userRole === "ADMIN"
    ? fields.filter(f => f.name === "sample")
    : fields;

  const selectedPlatform = mediaOptions.find(
    (opt) =>
      String(opt.id) === String(publicationData.platformName) ||
      opt.name === publicationData.platformName
  );

  console.log("Matched platform object:", selectedPlatform);

  return (
    <DashboardLayout sx={{ position: "sticky", top: 0, padding: "20rem", overflowY: "auto" }}>
      {(news.length > 0 || offers.length > 0) && <Popup open={openPopup} onClose={handleClose} />}
      <EditPublicationModel
        open={!!editId}
        onClose={() => setEditId(null)}
        title={userRole === 'ADMIN' ? "Edit Sample Only" : "Edit Publication"}
        onSave={handleEditPublication}
        fields={adminFields}
        onFieldChange={(e, fieldName) => {
          // ADMIN can only change sample
          if (userRole === 'ADMIN' && fieldName !== 'sample') return;

          setEditPublicationData((prevData) => ({
            ...prevData,
            [fieldName]: e.target.value,
          }));
        }}
        regions={regions}
      />
      <MDBox pt={1} pb={1} sx={{ height: "10vh", overFlowY: "auto" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={2}>
                {loading ? (
                  <CircularProgress />
                ) : isSmallScreen ? (
                  /* ================= 📱 MOBILE PUBLICATION LIST VIEW ================= */
                  <MDBox px={1.25} pb={2}>
                    {/* Header: hamburger / title / notifications / filter */}
                    <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2.5}>
                      <IconButton
                        size="small"
                        onClick={() => setMiniSidenav(dispatch, !miniSidenav)}
                        sx={{ p: 0.5 }}
                      >
                        <MenuIcon sx={{ color: "#1a1a1a" }} />
                      </IconButton>
                      <MDTypography variant="h5" fontWeight="bold" sx={{ color: "#1a1a1a" }}>
                        {selection === "package" ? "Social Media Marketplace" : "Online Media Marketplace"}
                      </MDTypography>
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <IconButton size="small" onClick={() => setOpenPopup(true)} sx={{ p: 0.5 }}>
                          <Badge badgeContent={news.length + offers.length} color="error">
                            <NotificationsNoneIcon sx={{ color: "#1a1a1a" }} />
                          </Badge>
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={handleOpenFilterModal}
                          sx={{
                            border: "1px solid #d7e3f5",
                            borderRadius: "8px",
                            p: 0.7,
                          }}
                        >
                          <FilterAltIcon fontSize="small" sx={{ color: "#1A83FF" }} />
                        </IconButton>
                      </MDBox>
                    </MDBox>

                    {/* Download Packages */}
                    <MDBox display="flex" alignItems="center" justifyContent="flex-end" gap={1} mb={2}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          if (downloadButtonLink && downloadButtonLink.trim() !== "") {
                            window.open(downloadButtonLink, "_blank");
                          } else {
                            setSnackbarMessage("Download link is still loading...");
                            setOpenSnackbar(true);
                            fetchAppLink();
                          }
                        }}
                        startIcon={<DownloadIcon sx={{ color: "white !important", fontSize: "1rem !important" }} />}
                        endIcon={<ArrowDropDownIcon sx={{ color: "white !important" }} />}
                        sx={{
                          backgroundColor: "#1A83FF !important",
                          color: "white !important",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          fontSize: "0.72rem",
                          fontWeight: "bold",
                          textTransform: "none",
                          border: "none",
                          boxShadow: "0px 2px 8px rgba(26, 131, 255, 0.35)",
                          whiteSpace: "nowrap",
                          minWidth: 0,
                        }}
                      >
                        Download Packages
                      </Button>
                    </MDBox>

                    {/* Search bar */}
                    <TextField
                      fullWidth
                      placeholder="Search publications..."
                      value={mobileSearchTerm}
                      onChange={(e) => setMobileSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: <SearchIcon sx={{ color: "#9e9e9e", mr: 1 }} fontSize="small" />,
                      }}
                      sx={{
                        mb: 2,
                        backgroundColor: "#fff",
                        "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                      }}
                    />

                    {/* Filters / Sort By / Download Excel */}
                    <MDBox display="flex" gap={1} mb={2}>
                      <Button
                        onClick={handleOpenFilterModal}
                        startIcon={<FilterAltIcon fontSize="small" />}
                        variant="outlined"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          height: "40px",
                          boxSizing: "border-box",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.75rem",
                          borderRadius: "8px",
                          color: "#1A83FF",
                          borderColor: "#1A83FF",
                          px: 1,
                        }}
                      >
                        Filters
                      </Button>

                      <FormControl sx={{ flex: 1, minWidth: 0, height: "40px" }} size="small">
                        <Select
                          value={sortOption}
                          onChange={(e) => setSortOption(e.target.value)}
                          renderValue={() => (
                            <MDBox display="flex" alignItems="center" gap={0.5}>
                              <SwapVertIcon fontSize="small" sx={{ color: "#5a5a5a" }} />
                              <MDTypography variant="caption" fontWeight="bold" sx={{ color: "#5a5a5a" }}>
                                Sort By
                              </MDTypography>
                              <ExpandMoreIcon sx={{ fontSize: "1rem", color: "#5a5a5a" }} />
                            </MDBox>
                          )}
                          IconComponent={() => null}
                          sx={{
                            height: "40px",
                            boxSizing: "border-box",
                            borderRadius: "8px",
                            fontSize: "0.75rem",
                            "& .MuiSelect-select": {
                              display: "flex",
                              alignItems: "center",
                              height: "40px",
                              boxSizing: "border-box",
                              py: 0,
                            },
                          }}
                        >
                          {mobileSortOptions.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <Button
                        onClick={handleDownloadExcel}
                        startIcon={<ExcelFileIcon size={16} />}
                        variant="outlined"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          height: "40px",
                          boxSizing: "border-box",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.75rem",
                          borderRadius: "8px",
                          color: "#3c3c3c",
                          borderColor: "#e0e0e0",
                          px: 1,
                        }}
                      >
                        Download Excel
                      </Button>
                    </MDBox>

                    {/* Publication list table (horizontally scrollable, same columns as desktop) */}
                    <MDBox
                      sx={{
                        border: "1px solid #edf0f4",
                        borderRadius: "10px",
                        width: "100%",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                      }}
                    >
                      <MDBox
                        sx={{
                          minWidth: `${modifiedColumns.reduce(
                            (sum, col) => sum + getMobileColWidth(col.accessor),
                            0
                          )}px`,
                        }}
                      >
                        {/* Header row */}
                        <MDBox
                          sx={{
                            display: "flex",
                            backgroundColor: "#f7f8fa",
                            py: 1,
                            px: 1,
                            borderBottom: "1px solid #edf0f4",
                          }}
                        >
                          {modifiedColumns.map((col, i) => (
                            <MDBox
                              key={col.accessor || i}
                              sx={{
                                flex: `0 0 ${getMobileColWidth(col.accessor)}px`,
                                width: `${getMobileColWidth(col.accessor)}px`,
                                pr: 1,
                                boxSizing: "border-box",
                              }}
                            >
                              <MDTypography
                                variant="caption"
                                fontWeight="bold"
                                sx={{
                                  color: "#5a5a5a",
                                  fontSize: "0.6rem",
                                  letterSpacing: "0.01em",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "block",
                                }}
                              >
                                {typeof col.Header === "string" ? col.Header.toUpperCase() : col.Header}
                              </MDTypography>
                            </MDBox>
                          ))}
                        </MDBox>

                        {/* Rows */}
                        {mobilePageRows.length === 0 ? (
                          <MDBox py={4} textAlign="center">
                            <MDTypography variant="button" color="secondary">
                              No publications found.
                            </MDTypography>
                          </MDBox>
                        ) : (
                          mobilePageRows.map((row, idx) => (
                            <MDBox
                              key={row.userId || row.packageName || idx}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                py: 1.25,
                                px: 1,
                                borderBottom: idx === mobilePageRows.length - 1 ? "none" : "1px solid #edf0f4",
                              }}
                            >
                              {modifiedColumns.map((col, i) => (
                                <MDBox
                                  key={col.accessor || i}
                                  sx={{
                                    flex: `0 0 ${getMobileColWidth(col.accessor)}px`,
                                    width: `${getMobileColWidth(col.accessor)}px`,
                                    pr: 1,
                                    boxSizing: "border-box",
                                    fontSize: "0.72rem",
                                    wordBreak: "break-word",
                                    "& .MuiIconButton-root": { padding: "2px", width: "22px", height: "22px" },
                                    "& svg": { fontSize: "0.95rem" },
                                    "& > div": col.accessor === "action" ? { display: "flex", gap: "2px" } : undefined,
                                  }}
                                >
                                  {renderMobileCellValue(col, row)}
                                </MDBox>
                              ))}
                            </MDBox>
                          ))
                        )}
                      </MDBox>
                    </MDBox>

                    {/* Pagination footer */}
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={1}
                      mt={2}
                    >
                      <MDTypography variant="button" color="secondary" fontWeight="regular">
                        Showing {mobileEntriesStart} to {mobileEntriesEnd} of {mobileFilteredRows.length} entries
                      </MDTypography>

                      <MDBox display="flex" alignItems="center" gap={1}>
                        <MDTypography variant="caption" color="secondary">
                          Rows per page:
                        </MDTypography>
                        <Select
                          size="small"
                          value={mobileRowsPerPage}
                          onChange={(e) => setMobileRowsPerPage(Number(e.target.value))}
                          sx={{ minWidth: 70, fontSize: "0.8rem" }}
                        >
                          {[5, 10, 15, 20, 25, 50].map((n) => (
                            <MenuItem key={n} value={n}>
                              {n}
                            </MenuItem>
                          ))}
                        </Select>

                        <MDBox
                          sx={{
                            border: "1px solid #1A83FF",
                            borderRadius: "6px",
                            color: "#1A83FF",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            px: 1.2,
                            py: 0.4,
                          }}
                        >
                          {mobilePage + 1}
                        </MDBox>

                        <IconButton
                          size="small"
                          disabled={mobilePage === 0}
                          onClick={() => setMobilePage((p) => Math.max(0, p - 1))}
                        >
                          <ChevronLeftIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          disabled={mobilePage >= mobileTotalPages - 1}
                          onClick={() => setMobilePage((p) => Math.min(mobileTotalPages - 1, p + 1))}
                          sx={{ color: "#1A83FF" }}
                        >
                          <ChevronRightIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                ) : (
                  <>

                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", sm: "row" }}
                      justifyContent="space-between"
                      alignItems={{ xs: "flex-start", sm: "center" }}
                      ml={3}
                      mr={{ xs: 1, sm: 3 }}
                      mb={2}
                      gap={1}
                    >
                      <MDBox>
                        <MDTypography variant="h5" fontWeight="bold" sx={{ color: "#1a1a1a" }}>
                          {isPackage ? "Social Media Marketplace" : "Online Media Marketplace"}
                        </MDTypography>
                        <MDTypography variant="button" sx={{ color: "#8a8a8a", fontWeight: 400 }}>
                          {isPackage
                            ? "Reach your audience through the official social networks of leading media brands."
                            : "Search, compare, and publish with confidence."}
                        </MDTypography>
                      </MDBox>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {userRole === "SUPER_ADMIN" && !isSmallScreen && !isPackage && (
                          <>
                            <Button
                              variant="outlined"
                              startIcon={<DeleteIcon fontSize="small" />}
                              onClick={handleBulkDelete}
                              sx={{ textTransform: "none", fontWeight: 600, borderRadius: "6px" }}
                              style={{ backgroundColor: "white", color: "#e34848", border: "1px solid #e34848" }}
                            >
                              Bulk Delete
                            </Button>

                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={<UploadFileIcon fontSize="small" />}
                              sx={{ textTransform: "none", fontWeight: 600, borderRadius: "6px" }}
                              style={{ backgroundColor: "white", color: "#1A83FF", border: "1px solid #1A83FF" }}
                            >
                              Bulk Edit Upload
                              <input
                                type="file"
                                hidden
                                accept=".xlsx, .xls"
                                onChange={handleBulkEditUpload}
                              />
                            </Button>
                          </>
                        )}

                        {userRole === "SUPER_ADMIN" && (
                          <IconButton onClick={handleLinkChange} sx={{ backgroundColor: "#f0f2f5" }}>
                            <EditIcon fontSize="small" />
                          </IconButton>
                        )}
                        <Button
                          variant="contained"
                          onClick={() => {
                            if (downloadButtonLink && downloadButtonLink.trim() !== "") {
                              window.open(downloadButtonLink, "_blank");
                            } else {
                              setSnackbarMessage("Download link is still loading...");
                              setOpenSnackbar(true);
                              fetchAppLink(); // Dubara koshish karein
                            }
                          }}
                          startIcon={<DownloadIcon sx={{ color: "white !important" }} />}
                          endIcon={<ArrowDropDownIcon sx={{ color: "white !important" }} />}
                          sx={{
                            backgroundColor: "#1A83FF !important",
                            color: "white !important",
                            borderRadius: "8px",
                            padding: "8px 18px",
                            fontSize: "0.95rem",
                            fontWeight: "bold",
                            textTransform: "none",
                            border: "none",
                            boxShadow: "0px 2px 8px rgba(26, 131, 255, 0.35)",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "#1a6fdb !important",
                              boxShadow: "0px 3px 10px rgba(26, 131, 255, 0.45)",
                            },
                          }}
                        >
                          {!isSmallScreen && "Download Packages"}
                        </Button>
                      </Box>
                    </MDBox>

                    <MDBox
                      display="flex"
                      alignItems="center"
                      gap={2}
                      // ml={3}
                      mb={0.5}
                    >
                      <Tooltip title="Filter Options">
                        <Button
                          variant="outlined"
                          startIcon={<FilterAltIcon fontSize="small" />}
                          sx={{ height: 40, marginBottom: 1, marginLeft: isSmallScreen ? 0 : 3, textTransform: "none", fontWeight: 600, borderRadius: "6px" }}
                          style={{ backgroundColor: "white", color: "#1A83FF", border: "1px solid #1A83FF" }}
                          onClick={handleOpenFilterModal}
                        >
                          Filters
                        </Button>
                      </Tooltip>

                      <Button
                        variant="text"
                        onClick={clearAllFilters}
                        sx={{ textTransform: "none", fontWeight: 500 }}
                        style={{ color: "#5a5a5a", padding: '5px', fontSize: '0.85rem', minHeight: '35px', marginTop: '-5px' }}
                      >
                        Clear Filters
                      </Button>

                      {(userRole === "SUPER_ADMIN" || userRole === "BUSINESS_TEAM") && (
                        isSmallScreen ? (
                          // 📱 Small screen: NO Box, NO Tooltip
                          <CustomerSearch />
                        ) : (
                          // 🖥️ Bigger screens: same as before
                          <Tooltip>
                            <Box
                              minWidth={200}
                              size="small"
                              sx={{ height: 40, marginLeft: "10px" }}
                            >
                              <CustomerSearch />
                            </Box>
                          </Tooltip>
                        )
                      )}

                    </MDBox>

                    {/* <DataTable
                      table={{
                        columns: modifiedColumns,
                        rows: selectedCustomer ? rows : modifiedRows,
                      }}
                      showTotalEntries
                      isSorted={false}
                      canSearch
                      handleDownloadExcel={handleDownloadExcel}
                    /> */}

                    <DataTable
                      table={{
                        columns: modifiedColumns,
                        rows: finalRows,
                      }}
                      showTotalEntries
                      isSorted={false}
                      canSearch
                      handleDownloadExcel={handleDownloadExcel}
                      onClearFilters={clearFilterTrigger}
                    />

                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>{isEdit ? "Edit" : "Add"} {isPackage ? "Social Media" : "Publication"}</DialogTitle>
        {!isEdit && (
          <MDBox>
            {
            isPackage === false ?
              <Button onClick={() => setPackages(false)}>Add Publication</Button>
              :
              <Button onClick={handleAddPackagesClick}>Add Social Media</Button>
            }
          </MDBox>
        )}
        <DialogContent>
          {/* {packages && isAdmin && isSuper && ( */}
          {!(isAdmin && isEdit) && (
            <>
              {isPackage && (isAdmin || isSuper) && (
                <>
                  <MDBox style={{ marginTop: "10px" }}>
                    <TextField
                      label="Social Media Marketplace"
                      name="packageName"
                      value={publicationData.packageName}
                      onChange={handleInputChange}
                      fullWidth
                      // disabled={isEdit}
                      // InputProps={{
                      //   readOnly: isEdit
                      // }}
                      sx={{ mb: 2 }}
                    />
                  </MDBox>

                  <Autocomplete
                    options={mediaOptions}
                    getOptionLabel={(option) => option.name || ""}
                    // ID base match karein ya name base
                    value={mediaOptions.find((opt) => opt.id === publicationData.platformName || opt.name === publicationData.platformName) || null}
                    onChange={(event, newValue) => {
                      setPublicationData((prev) => ({
                        ...prev,
                        platformName: newValue ? newValue.id : "",
                      }));
                    }}
                    renderInput={(params) => <TextField {...params} label="Select Platform" sx={{ mb: 2 }} />}
                  />
                </>
              )}
              {!isPackage && (
                <TextField
                  label="Online Media Marketplace"
                  fullWidth
                  name="publication"
                  value={publicationData.publication}
                  onChange={handleInputChange}
                  sx={{ mb: 2 }}
                />
              )}
              {/* {!isAdmin && isEdit && (
            <> */}
              <TextField
                label="Original Price"
                fullWidth
                name="orgPrice"
                value={publicationData.orgPrice}
                onChange={handleInputChange}
                type="number"
                sx={{ mb: 2 }}
                disabled={isEdit && isAdmin}
              />
              {!isPackage && (

                <>
                  <TextField
                    label="Words Allowed"
                    fullWidth
                    name="wordsAllowed"
                    value={publicationData.wordsAllowed}
                    onChange={handleInputChange}
                    type="number"
                    sx={{ mb: 2 }}
                    disabled={isEdit && isAdmin}

                  />
                  <TextField
                    label="No.of Backlinks"
                    fullWidth
                    name="backlinksAllowed"
                    value={publicationData.backlinksAllowed}
                    onChange={handleInputChange}
                    type="number"
                    sx={{ mb: 2 }}
                    disabled={isEdit && isAdmin}

                  />
                  <Autocomplete
                    multiple
                    options={disclaimerOptions}
                    value={publicationData.disclaimer || []}
                    onChange={handleDisclamerChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Disclaimer"
                        placeholder="Select Disclaimer"
                        sx={{ mb: 2 }}
                      />
                    )}
                    disabled={isEdit && isAdmin}

                  />
                </>
              )}

              <Autocomplete
                multiple
                options={genresOptions}
                value={publicationData.genres || []}
                onChange={handleGenresChange}
                renderInput={(params) => (
                  <TextField {...params} label="Genres" placeholder="Select genres" sx={{ mb: 2 }} />
                )}
                disabled={isEdit && isAdmin}

              />

            </>
          )}
          {/* {!packages && ( */}
          <TextField
            label="Sample"
            fullWidth
            name="sample"
            value={publicationData.sample}
            onChange={handleInputChange}
            sx={{ mb: 2 }}
          />

          {/* <Autocomplete
  options={mediaOptions}
  getOptionLabel={(option) => option.name || ""}
  value={selectedPlatform || null}
  onChange={(event, newValue) => {
    setPublicationData((prev) => ({
      ...prev,
      platformName: newValue ? newValue.id : "",
    }));
  }}
  renderInput={(params) => (
    <TextField {...params} label="Select Platform" sx={{ mb: 2 }} />
  )}
/> */}
          {/* )} */}
          {!(isAdmin && isEdit) && (
            <>
              <TextField
                label="TAT (Turnaround Time)"
                fullWidth
                name="tat"
                value={publicationData.tat}
                onChange={handleInputChange}
                sx={{ mb: 2 }}
                disabled={isEdit && isAdmin}
              />
              {isPackage && (
                <FormControl fullWidth component="fieldset" sx={{ mb: 3 }}
                  disabled={isEdit && isAdmin}
                >
                  {/* Label */}
                  <InputLabel
                    shrink
                    sx={{
                      fontSize: "0.85rem",
                      fontWeight: 500,
                      color: "text.primary",
                      mb: 1,
                    }}
                  >
                    Collab
                  </InputLabel>

                  {/* Radios */}
                  <RadioGroup
                    row
                    name="collab"
                    value={publicationData.collab}
                    onChange={handleRadioChange}
                    sx={{
                      gap: 3,                 // 👈 spacing between options
                      pl: 0.5,                // 👈 slight left indent
                    }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio size="small" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio size="small" />}
                      label="No"
                    />
                    <FormControlLabel
                      value="maybe"
                      control={<Radio size="small" />}
                      label="May Be"
                    />
                  </RadioGroup>
                </FormControl>
              )}
              {!isPackage && (
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Region</InputLabel>
                  <Select
                    labelId="modeType-select-label"
                    name="modeType"
                    value={publicationData.modeType}
                    onChange={handleInputChange}
                    label="Region"
                    sx={{ padding: "10px" }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: "160px",
                          overflowY: "auto",
                          "&::-webkit-scrollbar": {
                            display: "none",
                          },
                          scrollbarWidth: "none",
                          "-ms-overflow-style": "none",
                        },
                      },
                    }}
                    disabled={isEdit && isAdmin}

                  >
                    <MenuItem value="">None</MenuItem>
                    {regions?.length > 0 ? (
                      regions.map((region) => (
                        <MenuItem key={region.regionId} value={region.region}>
                          {region.region.toUpperCase()}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled value="">
                        Loading...
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              )}
              {!isPackage && (
                <>
                  <FormControl fullWidth component="fieldset" sx={{ mb: 3 }}
                    disabled={isEdit && isAdmin}

                  >
                    {/* Label */}
                    <InputLabel
                      shrink
                      sx={{
                        fontSize: "0.85rem",
                        fontWeight: 500,
                        color: "text.primary",
                        mb: 1,
                      }}
                    >
                      Indexed
                    </InputLabel>

                    {/* Radios */}
                    <RadioGroup
                      row
                      name="index2"
                      value={publicationData.index2}
                      onChange={handleRadioChange}
                      sx={{
                        gap: 3,                 // 👈 spacing between options
                        pl: 0.5,                // 👈 slight left indent
                      }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio size="small" />}
                        label="No"
                      />
                      <FormControlLabel
                        value="maybe"
                        control={<Radio size="small" />}
                        label="May Be"
                      />
                    </RadioGroup>
                  </FormControl>

                  <FormControl fullWidth component="fieldset" sx={{ mb: 2 }}
                    disabled={isEdit && isAdmin}

                  >
                    {/* Label */}
                    <InputLabel
                      shrink
                      sx={{
                        fontSize: "0.85rem",
                        fontWeight: 500,
                        color: "text.primary",
                        mb: 1,
                      }}
                    >
                      Do Follow
                    </InputLabel>

                    {/* Radios */}
                    <RadioGroup
                      row
                      name="doFollow2"
                      value={publicationData.doFollow2}
                      onChange={handleRadioChange}
                      sx={{
                        gap: 3,
                        pl: 0.5,
                      }}
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio size="small" />}
                        label="No"
                      />
                      <FormControlLabel
                        value="maybe"
                        control={<Radio size="small" />}
                        label="May Be"
                      />
                    </RadioGroup>
                  </FormControl>
                </>

              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSavePublication} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={bulkEditOpen} onClose={handleCloseBulkEdit} fullWidth maxWidth="sm">
        <DialogTitle>Bulk Edit Publications</DialogTitle>
        <DialogContent>
          <TextField
            label="Original Price (leave blank to skip)"
            fullWidth
            name="orgPrice"
            value={bulkData.orgPrice}
            onChange={handleBulkInputChange}
            type="number"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Words Allowed (leave blank to skip)"
            fullWidth
            name="wordsAllowed"
            value={bulkData.wordsAllowed}
            onChange={handleBulkInputChange}
            type="number"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Backlinks Allowed (leave blank to skip)"
            fullWidth
            name="backlinksAllowed"
            value={bulkData.backlinksAllowed}
            onChange={handleBulkInputChange}
            sx={{ mb: 2 }}
          />
          <TextField
            label="TAT (leave blank to skip)"
            fullWidth
            name="tat"
            value={bulkData.tat}
            onChange={handleBulkInputChange}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Sample (leave blank to skip)"
            fullWidth
            name="sample"
            value={bulkData.sample}
            onChange={handleBulkInputChange}
            sx={{ mb: 2 }}
          />
          <TextField
            label="DA Checker (leave blank to skip)"
            fullWidth
            name="daChecker"
            value={bulkData.daChecker}
            onChange={handleBulkInputChange}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Traffic Checker (leave blank to skip)"
            fullWidth
            name="trafficChecker"
            value={bulkData.trafficChecker}
            onChange={handleBulkInputChange}
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Region (leave blank to skip)</InputLabel>
            <Select
              name="modeType"
              value={bulkData.modeType}
              onChange={handleBulkInputChange}
              label="Region (leave blank to skip)"
            >
              <MenuItem value="">Skip</MenuItem>
              {regions?.map((region) => (
                <MenuItem key={region.regionId} value={region.region}>
                  {region.region.toUpperCase()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBulkEdit} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveBulkEdit} color="primary">
            Apply to Selected
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isFilterModalOpen} onClose={handleCloseFilterModal} fullWidth maxWidth="md">
        <DialogTitle>Filter Options</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {!isPackage && (
              <>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="index2-select-label">Indexed</InputLabel>
                    <Select
                      labelId="index2-select-label"
                      name="index2"
                      value={filters.index2 || ""}
                      onChange={handleChange}
                      label="Indexed"
                      sx={{ padding: "10px" }}
                    >
                      <MenuItem value="">None</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="maybe">Maybe</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    fullWidth
                    size="small"
                    options={regions || []}
                    getOptionLabel={(option) => option?.region?.toUpperCase() || ''}
                    isOptionEqualToValue={(option, value) =>
                      option?.regionId === value?.regionId
                    }
                    value={
                      filtersForMode.modeType === null
                        ? null
                        : regions?.find(r => r.region === filtersForMode.modeType) || null
                    }
                    onChange={(event, newValue) => {
                      handleChangeForMode({
                        target: {
                          name: 'modeType',
                          value: newValue?.region || null
                        }
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Region"
                        InputProps={{
                          ...params.InputProps,
                          style: { padding: '10px' }
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem {...props} key={option.regionId} value={option.region}>
                        {option.region.toUpperCase()}
                      </MenuItem>
                    )}
                    noOptionsText="No regions found"
                    sx={{
                      '& .MuiAutocomplete-paper': {
                        maxHeight: '160px',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        '-ms-overflow-style': 'none',
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="doFollow-select-label">Do Follow</InputLabel>
                    <Select
                      labelId="doFollow-select-label"
                      name="doFollow2"
                      value={filters.doFollow2 || ""}
                      onChange={handleChange}
                      label="Do Follow"
                      sx={{ padding: "10px" }}
                    >
                      <MenuItem value="">None</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="maybe">Maybe</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </>

            )}

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="genre-select-label">Genre</InputLabel>
                <Select
                  labelId="genre-select-label"
                  value={selectedGenres[0] || ""}
                  onChange={(event) => setSelectedGenres([event.target.value])}
                  label="Genre"
                  sx={{ padding: "10px" }}
                >
                  {genresOptions.map((genre) => (
                    <MenuItem key={genre} value={genre}>
                      {genre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {isPackage && (
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth size="small">
                  <InputLabel id="platform-filter-label">Platform</InputLabel>
                  {/* Filter Modal ke andar Platform Select */}
                  <Select
                    labelId="platform-filter-label"
                    name="platformName"
                    value={filters.platformName || ""}
                    onChange={handleChange}
                    label="Platform"
                    sx={{ padding: "10px" }}
                  >
                    <MenuItem value="">All Platforms</MenuItem>
                    {/* rows state se unique names nikalna hamesha kaam karta hai */}
                    {[...new Set(rows.map(r => r.platformName))].filter(Boolean).map((plat) => (
                      <MenuItem key={plat} value={plat}>
                        {plat}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {!isPackage && (
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth size="small">
                  <InputLabel id="disclaimer-select-label">Disclaimer</InputLabel>
                  <Select
                    labelId="disclaimer-select-label"
                    value={selectedDisclaimer[0] || ""}
                    onChange={(event) => setSelectedDisclaimer([event.target.value])}
                    label="Disclaimer"
                    sx={{ padding: "10px" }}
                  >
                    {disclaimerOptions.map((disclaimer) => (
                      <MenuItem key={disclaimer} value={disclaimer}>
                        {disclaimer}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={6} sm={2} style={{ marginTop: "5px" }}>
              <TextField
                fullWidth
                label="Min Value"
                type="number"
                size="small"
                variant="outlined"
                value={minInput}
                onChange={(e) => {
                  const val = e.target.value;
                  setMinInput(val);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={2} style={{ marginTop: "5px" }}>
              <TextField
                fullWidth
                label="Max Value"
                type="number"
                size="small"
                variant="outlined"
                value={maxInput}
                onChange={(e) => setMaxInput(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" flexWrap="wrap" gap={1} justifyContent="flex-start" mt={2}>

                {["SUPER_ADMIN"].includes(userRole) && (
                  <>
                    {/* {!isPackage && (
                      <> */}
                    <Tooltip title="Download Template">
                      <Button
                        variant="outlined"
                        onClick={handleTemplateDownload}
                        style={{
                          backgroundColor: "white",
                          color: "grey",
                          border: "1px solid #49a3f1",
                        }}
                      >
                        <DownloadIcon />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Upload Excel File for Add">
                      <Button
                        variant="outlined"
                        component="label"
                        style={{
                          backgroundColor: "white",
                          color: "grey",
                          border: "1px solid #49a3f1",
                        }}
                      >
                        {uploading ? <CircularProgress size={20} /> : <UploadFileIcon />}
                        <input hidden accept=".xlsx" type="file" onChange={handleFileUpload} />
                      </Button>
                    </Tooltip>
                    {/* </>
                    )} */}

                    <Tooltip title="Add Publication">
                      <Button
                        variant="outlined"
                        onClick={handleOpenModal}
                        style={{
                          backgroundColor: "white",
                          color: "grey",
                          border: "1px solid #49a3f1",
                        }}
                      >
                        ADD
                      </Button>
                    </Tooltip>
                  </>
                )}
                {isSmallScreen ? (
                  <Tooltip title="Sign Out">
                    <Button
                      variant="contained"
                      sx={{
                        height: 40,
                        minWidth: 40,
                      }}
                      style={{
                        backgroundColor: "white",
                        color: "grey",
                      }}
                      onClick={handleSignOut}
                    >
                      <Logout />
                    </Button>
                  </Tooltip>
                ) : (
                  ""
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseFilterModal} color="secondary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={
            snackbarMessage.includes('successfully') ||
              snackbarMessage.includes('created') ||
              snackbarMessage.includes('updated')
              ? 'success'
              : 'error'
          }
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={deleteBox} onClose={handleDeleteCancel} fullWidth maxWidth="sm">
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this publication?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} color="primary">
            Confirm
          </Button>
          <Button onClick={handleDeleteCancel} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deletePackageBox} onClose={handleDeleteCancelPackage} fullWidth maxWidth="sm">
        <DialogTitle>Confirm Delete Social Media</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this Social Media?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeletePackage} color="primary">
            Confirm
          </Button>
          <Button onClick={handleDeleteCancelPackage} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Tables;